import { createContext as Pe, useContext as Re, useState as He, useRef as Te, useEffect as ne, useCallback as ze, useMemo as ie } from "react";
import { jsx as $e, Fragment as Ae, jsxs as Je } from "react/jsx-runtime";
import { createPolymorphicComponent as Ye, Text as We } from "@inflearn/ds-react";
import le from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/ko";
import Xe from "dayjs/plugin/localizedFormat";
import Ze from "dayjs/plugin/updateLocale";
import { jsx as Qe } from "@emotion/react/jsx-runtime";
var D = { ko: "ko", en: "en", ja: "ja", vi: "vi" }, se = D.ko;
Object.values(D);
const qe = (...i) => {
  console != null && console.warn && (F(i[0]) && (i[0] = `react-i18next:: ${i[0]}`), console.warn(...i));
}, he = {}, re = (...i) => {
  F(i[0]) && he[i[0]] || (F(i[0]) && (he[i[0]] = /* @__PURE__ */ new Date()), qe(...i));
}, Fe = (i, e) => () => {
  if (i.isInitialized)
    e();
  else {
    const t = () => {
      setTimeout(() => {
        i.off("initialized", t);
      }, 0), e();
    };
    i.on("initialized", t);
  }
}, ge = (i, e, t) => {
  i.loadNamespaces(e, Fe(i, t));
}, fe = (i, e, t, n) => {
  F(t) && (t = [t]), t.forEach((s) => {
    i.options.ns.indexOf(s) < 0 && i.options.ns.push(s);
  }), i.loadLanguages(e, Fe(i, n));
}, _e = (i, e, t = {}) => !e.languages || !e.languages.length ? (re("i18n.languages were undefined or empty", e.languages), !0) : e.hasLoadedNamespace(i, {
  lng: t.lng,
  precheck: (n, s) => {
    var r;
    if (((r = t.bindI18n) == null ? void 0 : r.indexOf("languageChanging")) > -1 && n.services.backendConnector.backend && n.isLanguageChangingTo && !s(n.isLanguageChangingTo, i))
      return !1;
  }
}), F = (i) => typeof i == "string", et = (i) => typeof i == "object" && i !== null, tt = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, nt = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, it = (i) => nt[i], st = (i) => i.replace(tt, it);
let ae = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: st
};
const rt = (i = {}) => {
  ae = {
    ...ae,
    ...i
  };
}, at = () => ae;
let Ee;
const ot = (i) => {
  Ee = i;
}, lt = () => Ee, ut = {
  type: "3rdParty",
  init(i) {
    rt(i.options.react), ot(i);
  }
}, ct = Pe();
class ht {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(e) {
    e.forEach((t) => {
      this.usedNamespaces[t] || (this.usedNamespaces[t] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const gt = (i, e) => {
  const t = Te();
  return ne(() => {
    t.current = e ? t.current : i;
  }, [i, e]), t.current;
}, je = (i, e, t, n) => i.getFixedT(e, t, n), ft = (i, e, t, n) => ze(je(i, e, t, n), [i, e, t, n]), dt = (i, e = {}) => {
  var y, k, I, S;
  const {
    i18n: t
  } = e, {
    i18n: n,
    defaultNS: s
  } = Re(ct) || {}, r = t || n || lt();
  if (r && !r.reportNamespaces && (r.reportNamespaces = new ht()), !r) {
    re("You will need to pass in an i18next instance by using initReactI18next");
    const v = (P, C) => F(C) ? C : et(C) && F(C.defaultValue) ? C.defaultValue : Array.isArray(P) ? P[P.length - 1] : P, T = [v, {}, !1];
    return T.t = v, T.i18n = {}, T.ready = !1, T;
  }
  (y = r.options.react) != null && y.wait && re("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const a = {
    ...at(),
    ...r.options.react,
    ...e
  }, {
    useSuspense: o,
    keyPrefix: l
  } = a;
  let u = i || s || ((k = r.options) == null ? void 0 : k.defaultNS);
  u = F(u) ? [u] : u || ["translation"], (S = (I = r.reportNamespaces).addUsedNamespaces) == null || S.call(I, u);
  const h = (r.isInitialized || r.initializedStoreOnce) && u.every((v) => _e(v, r, a)), g = ft(r, e.lng || null, a.nsMode === "fallback" ? u : u[0], l), c = () => g, f = () => je(r, e.lng || null, a.nsMode === "fallback" ? u : u[0], l), [p, b] = He(c);
  let m = u.join();
  e.lng && (m = `${e.lng}${m}`);
  const w = gt(m), x = Te(!0);
  ne(() => {
    const {
      bindI18n: v,
      bindI18nStore: T
    } = a;
    x.current = !0, !h && !o && (e.lng ? fe(r, e.lng, u, () => {
      x.current && b(f);
    }) : ge(r, u, () => {
      x.current && b(f);
    })), h && w && w !== m && x.current && b(f);
    const P = () => {
      x.current && b(f);
    };
    return v && (r == null || r.on(v, P)), T && (r == null || r.store.on(T, P)), () => {
      x.current = !1, r && (v == null || v.split(" ").forEach((C) => r.off(C, P))), T && r && T.split(" ").forEach((C) => r.store.off(C, P));
    };
  }, [r, m]), ne(() => {
    x.current && h && b(c);
  }, [r, l, h]);
  const R = [p, r, h];
  if (R.t = p, R.i18n = r, R.ready = h, h || !h && !o)
    return R;
  throw new Promise((v) => {
    e.lng ? fe(r, e.lng, u, () => v()) : ge(r, u, () => v());
  });
};
var pt = { [D.ko]: "82", [D.en]: "1", [D.ja]: "81", [D.vi]: "84" }, N = { ko: "ko-KR", en: "en-US", ja: "ja-JP", vi: "vi-VN" };
function mt() {
  let { i18n: i } = dt();
  return ie(() => {
    let e = i.language || se;
    return { lang: e, locale: N[e], countryCode: pt[e], isKo: e === se };
  }, [i.language]);
}
var vn = ({ children: i }) => {
  let { isKo: e } = mt();
  return $e(Ae, { children: e && i });
};
le.extend(Ze);
le.extend(Xe);
le.updateLocale("ko", { formats: { L: "YYYY. MM. DD.", LL: "YYYY년 MM월 DD일", LT: "A h:mm" } });
var H = { [N.ko]: "KRW", [N.en]: "USD", [N.ja]: "JPY", [N.vi]: "VND" }, bt = { [H[N.ko]]: N.ko, [H[N.en]]: N.en, [H[N.ja]]: N.ja, [H[N.vi]]: N.vi }, yt = (i, e) => new Intl.NumberFormat(i, { style: "currency", currency: e }), xt = ({ locale: i, amount: e, currency: t, hiddenKRW: n = !1, leftSection: s = "", rightSection: r = "", ...a }) => {
  let o = i ?? bt[t ?? N.ko], l = t ?? H[o], u = ie(() => yt(o, l), [o, l]), h = ie(() => n && i === N.ko ? e.toLocaleString() : u.format(Number(e)), [i, u, e, n]);
  return $e(We, { ...a, children: Je(Ae, { children: [s, h, r] }) });
}, wn = Ye(xt);
const St = () => typeof window < "u", d = (i) => typeof i == "string", K = () => {
  let i, e;
  const t = new Promise((n, s) => {
    i = n, e = s;
  });
  return t.resolve = i, t.reject = e, t;
}, de = (i) => i == null ? "" : "" + i, vt = (i, e, t) => {
  i.forEach((n) => {
    e[n] && (t[n] = e[n]);
  });
}, wt = /###/g, pe = (i) => i && i.indexOf("###") > -1 ? i.replace(wt, ".") : i, me = (i) => !i || d(i), z = (i, e, t) => {
  const n = d(e) ? e.split(".") : e;
  let s = 0;
  for (; s < n.length - 1; ) {
    if (me(i))
      return {};
    const r = pe(n[s]);
    !i[r] && t && (i[r] = new t()), Object.prototype.hasOwnProperty.call(i, r) ? i = i[r] : i = {}, ++s;
  }
  return me(i) ? {} : {
    obj: i,
    k: pe(n[s])
  };
}, be = (i, e, t) => {
  const {
    obj: n,
    k: s
  } = z(i, e, Object);
  if (n !== void 0 || e.length === 1) {
    n[s] = t;
    return;
  }
  let r = e[e.length - 1], a = e.slice(0, e.length - 1), o = z(i, a, Object);
  for (; o.obj === void 0 && a.length; )
    r = `${a[a.length - 1]}.${r}`, a = a.slice(0, a.length - 1), o = z(i, a, Object), o && o.obj && typeof o.obj[`${o.k}.${r}`] < "u" && (o.obj = void 0);
  o.obj[`${o.k}.${r}`] = t;
}, kt = (i, e, t, n) => {
  const {
    obj: s,
    k: r
  } = z(i, e, Object);
  s[r] = s[r] || [], s[r].push(t);
}, X = (i, e) => {
  const {
    obj: t,
    k: n
  } = z(i, e);
  if (t)
    return t[n];
}, Lt = (i, e, t) => {
  const n = X(i, t);
  return n !== void 0 ? n : X(e, t);
}, De = (i, e, t) => {
  for (const n in e)
    n !== "__proto__" && n !== "constructor" && (n in i ? d(i[n]) || i[n] instanceof String || d(e[n]) || e[n] instanceof String ? t && (i[n] = e[n]) : De(i[n], e[n], t) : i[n] = e[n]);
  return i;
}, E = (i) => i.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var Ct = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const Nt = (i) => d(i) ? i.replace(/[&<>"'\/]/g, (e) => Ct[e]) : i;
class It {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const t = this.regExpMap.get(e);
    if (t !== void 0)
      return t;
    const n = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, n), this.regExpQueue.push(e), n;
  }
}
const Ot = [" ", ",", "?", "!", ";"], Pt = new It(20), Rt = (i, e, t) => {
  e = e || "", t = t || "";
  const n = Ot.filter((a) => e.indexOf(a) < 0 && t.indexOf(a) < 0);
  if (n.length === 0)
    return !0;
  const s = Pt.getRegExp(`(${n.map((a) => a === "?" ? "\\?" : a).join("|")})`);
  let r = !s.test(i);
  if (!r) {
    const a = i.indexOf(t);
    a > 0 && !s.test(i.substring(0, a)) && (r = !0);
  }
  return r;
}, oe = function(i, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!i)
    return;
  if (i[e])
    return i[e];
  const n = e.split(t);
  let s = i;
  for (let r = 0; r < n.length; ) {
    if (!s || typeof s != "object")
      return;
    let a, o = "";
    for (let l = r; l < n.length; ++l)
      if (l !== r && (o += t), o += n[l], a = s[o], a !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof a) > -1 && l < n.length - 1)
          continue;
        r += l - r + 1;
        break;
      }
    s = a;
  }
  return s;
}, Z = (i) => i && i.replace("_", "-"), Tt = {
  type: "logger",
  log(i) {
    this.output("log", i);
  },
  warn(i) {
    this.output("warn", i);
  },
  error(i) {
    this.output("error", i);
  },
  output(i, e) {
    console && console[i] && console[i].apply(console, e);
  }
};
class Q {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(e, t);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = t.prefix || "i18next:", this.logger = e || Tt, this.options = t, this.debug = t.debug;
  }
  log() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return this.forward(t, "log", "", !0);
  }
  warn() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return this.forward(t, "warn", "", !0);
  }
  error() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return this.forward(t, "error", "");
  }
  deprecate() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, t, n, s) {
    return s && !this.debug ? null : (d(e[0]) && (e[0] = `${n}${this.prefix} ${e[0]}`), this.logger[t](e));
  }
  create(e) {
    return new Q(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new Q(this.logger, e);
  }
}
var $ = new Q();
class _ {
  constructor() {
    this.observers = {};
  }
  on(e, t) {
    return e.split(" ").forEach((n) => {
      this.observers[n] || (this.observers[n] = /* @__PURE__ */ new Map());
      const s = this.observers[n].get(t) || 0;
      this.observers[n].set(t, s + 1);
    }), this;
  }
  off(e, t) {
    if (this.observers[e]) {
      if (!t) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(t);
    }
  }
  emit(e) {
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)
      n[s - 1] = arguments[s];
    this.observers[e] && Array.from(this.observers[e].entries()).forEach((a) => {
      let [o, l] = a;
      for (let u = 0; u < l; u++)
        o(...n);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((a) => {
      let [o, l] = a;
      for (let u = 0; u < l; u++)
        o.apply(o, [e, ...n]);
    });
  }
}
class ye extends _ {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = e || {}, this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const t = this.options.ns.indexOf(e);
    t > -1 && this.options.ns.splice(t, 1);
  }
  getResource(e, t, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const r = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator, a = s.ignoreJSONStructure !== void 0 ? s.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let o;
    e.indexOf(".") > -1 ? o = e.split(".") : (o = [e, t], n && (Array.isArray(n) ? o.push(...n) : d(n) && r ? o.push(...n.split(r)) : o.push(n)));
    const l = X(this.data, o);
    return !l && !t && !n && e.indexOf(".") > -1 && (e = o[0], t = o[1], n = o.slice(2).join(".")), l || !a || !d(n) ? l : oe(this.data && this.data[e] && this.data[e][t], n, r);
  }
  addResource(e, t, n, s) {
    let r = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const a = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator;
    let o = [e, t];
    n && (o = o.concat(a ? n.split(a) : n)), e.indexOf(".") > -1 && (o = e.split("."), s = t, t = o[1]), this.addNamespaces(t), be(this.data, o, s), r.silent || this.emit("added", e, t, n, s);
  }
  addResources(e, t, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const r in n)
      (d(n[r]) || Array.isArray(n[r])) && this.addResource(e, t, r, n[r], {
        silent: !0
      });
    s.silent || this.emit("added", e, t, n);
  }
  addResourceBundle(e, t, n, s, r) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, o = [e, t];
    e.indexOf(".") > -1 && (o = e.split("."), s = n, n = t, t = o[1]), this.addNamespaces(t);
    let l = X(this.data, o) || {};
    a.skipCopy || (n = JSON.parse(JSON.stringify(n))), s ? De(l, n, r) : l = {
      ...l,
      ...n
    }, be(this.data, o, l), a.silent || this.emit("added", e, t, n);
  }
  removeResourceBundle(e, t) {
    this.hasResourceBundle(e, t) && delete this.data[e][t], this.removeNamespaces(t), this.emit("removed", e, t);
  }
  hasResourceBundle(e, t) {
    return this.getResource(e, t) !== void 0;
  }
  getResourceBundle(e, t) {
    return t || (t = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(e, t)
    } : this.getResource(e, t);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const t = this.getDataByLanguage(e);
    return !!(t && Object.keys(t) || []).find((s) => t[s] && Object.keys(t[s]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Ve = {
  processors: {},
  addPostProcessor(i) {
    this.processors[i.name] = i;
  },
  handle(i, e, t, n, s) {
    return i.forEach((r) => {
      this.processors[r] && (e = this.processors[r].process(e, t, n, s));
    }), e;
  }
};
const xe = {};
class q extends _ {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), vt(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = $.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (e == null)
      return !1;
    const n = this.resolve(e, t);
    return n && n.res !== void 0;
  }
  extractFromKey(e, t) {
    let n = t.nsSeparator !== void 0 ? t.nsSeparator : this.options.nsSeparator;
    n === void 0 && (n = ":");
    const s = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator;
    let r = t.ns || this.options.defaultNS || [];
    const a = n && e.indexOf(n) > -1, o = !this.options.userDefinedKeySeparator && !t.keySeparator && !this.options.userDefinedNsSeparator && !t.nsSeparator && !Rt(e, n, s);
    if (a && !o) {
      const l = e.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: e,
          namespaces: r
        };
      const u = e.split(n);
      (n !== s || n === s && this.options.ns.indexOf(u[0]) > -1) && (r = u.shift()), e = u.join(s);
    }
    return d(r) && (r = [r]), {
      key: e,
      namespaces: r
    };
  }
  translate(e, t, n) {
    if (typeof t != "object" && this.options.overloadTranslationOptionHandler && (t = this.options.overloadTranslationOptionHandler(arguments)), typeof t == "object" && (t = {
      ...t
    }), t || (t = {}), e == null)
      return "";
    Array.isArray(e) || (e = [String(e)]);
    const s = t.returnDetails !== void 0 ? t.returnDetails : this.options.returnDetails, r = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator, {
      key: a,
      namespaces: o
    } = this.extractFromKey(e[e.length - 1], t), l = o[o.length - 1], u = t.lng || this.language, h = t.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (u && u.toLowerCase() === "cimode") {
      if (h) {
        const y = t.nsSeparator || this.options.nsSeparator;
        return s ? {
          res: `${l}${y}${a}`,
          usedKey: a,
          exactUsedKey: a,
          usedLng: u,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(t)
        } : `${l}${y}${a}`;
      }
      return s ? {
        res: a,
        usedKey: a,
        exactUsedKey: a,
        usedLng: u,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(t)
      } : a;
    }
    const g = this.resolve(e, t);
    let c = g && g.res;
    const f = g && g.usedKey || a, p = g && g.exactUsedKey || a, b = Object.prototype.toString.apply(c), m = ["[object Number]", "[object Function]", "[object RegExp]"], w = t.joinArrays !== void 0 ? t.joinArrays : this.options.joinArrays, x = !this.i18nFormat || this.i18nFormat.handleAsObject, R = !d(c) && typeof c != "boolean" && typeof c != "number";
    if (x && c && R && m.indexOf(b) < 0 && !(d(w) && Array.isArray(c))) {
      if (!t.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const y = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(f, c, {
          ...t,
          ns: o
        }) : `key '${a} (${this.language})' returned an object instead of string.`;
        return s ? (g.res = y, g.usedParams = this.getUsedParamsDetails(t), g) : y;
      }
      if (r) {
        const y = Array.isArray(c), k = y ? [] : {}, I = y ? p : f;
        for (const S in c)
          if (Object.prototype.hasOwnProperty.call(c, S)) {
            const v = `${I}${r}${S}`;
            k[S] = this.translate(v, {
              ...t,
              joinArrays: !1,
              ns: o
            }), k[S] === v && (k[S] = c[S]);
          }
        c = k;
      }
    } else if (x && d(w) && Array.isArray(c))
      c = c.join(w), c && (c = this.extendTranslation(c, e, t, n));
    else {
      let y = !1, k = !1;
      const I = t.count !== void 0 && !d(t.count), S = q.hasDefaultValue(t), v = I ? this.pluralResolver.getSuffix(u, t.count, t) : "", T = t.ordinal && I ? this.pluralResolver.getSuffix(u, t.count, {
        ordinal: !1
      }) : "", P = I && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), C = P && t[`defaultValue${this.options.pluralSeparator}zero`] || t[`defaultValue${v}`] || t[`defaultValue${T}`] || t.defaultValue;
      !this.isValidLookup(c) && S && (y = !0, c = C), this.isValidLookup(c) || (k = !0, c = a);
      const Ge = (t.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && k ? void 0 : c, V = S && C !== c && this.options.updateMissing;
      if (k || y || V) {
        if (this.logger.log(V ? "updateKey" : "missingKey", u, l, a, V ? C : c), r) {
          const O = this.resolve(a, {
            ...t,
            keySeparator: !1
          });
          O && O.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let M = [];
        const Y = this.languageUtils.getFallbackCodes(this.options.fallbackLng, t.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && Y && Y[0])
          for (let O = 0; O < Y.length; O++)
            M.push(Y[O]);
        else
          this.options.saveMissingTo === "all" ? M = this.languageUtils.toResolveHierarchy(t.lng || this.language) : M.push(t.lng || this.language);
        const ue = (O, A, U) => {
          const ce = S && U !== c ? U : Ge;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(O, l, A, ce, V, t) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(O, l, A, ce, V, t), this.emit("missingKey", O, l, A, c);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && I ? M.forEach((O) => {
          const A = this.pluralResolver.getSuffixes(O, t);
          P && t[`defaultValue${this.options.pluralSeparator}zero`] && A.indexOf(`${this.options.pluralSeparator}zero`) < 0 && A.push(`${this.options.pluralSeparator}zero`), A.forEach((U) => {
            ue([O], a + U, t[`defaultValue${U}`] || C);
          });
        }) : ue(M, a, C));
      }
      c = this.extendTranslation(c, e, t, g, n), k && c === a && this.options.appendNamespaceToMissingKey && (c = `${l}:${a}`), (k || y) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? c = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${a}` : a, y ? c : void 0) : c = this.options.parseMissingKeyHandler(c));
    }
    return s ? (g.res = c, g.usedParams = this.getUsedParamsDetails(t), g) : c;
  }
  extendTranslation(e, t, n, s, r) {
    var a = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...n
      }, n.lng || this.language || s.usedLng, s.usedNS, s.usedKey, {
        resolved: s
      });
    else if (!n.skipInterpolation) {
      n.interpolation && this.interpolator.init({
        ...n,
        interpolation: {
          ...this.options.interpolation,
          ...n.interpolation
        }
      });
      const u = d(e) && (n && n.interpolation && n.interpolation.skipOnVariables !== void 0 ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let h;
      if (u) {
        const c = e.match(this.interpolator.nestingRegexp);
        h = c && c.length;
      }
      let g = n.replace && !d(n.replace) ? n.replace : n;
      if (this.options.interpolation.defaultVariables && (g = {
        ...this.options.interpolation.defaultVariables,
        ...g
      }), e = this.interpolator.interpolate(e, g, n.lng || this.language || s.usedLng, n), u) {
        const c = e.match(this.interpolator.nestingRegexp), f = c && c.length;
        h < f && (n.nest = !1);
      }
      !n.lng && this.options.compatibilityAPI !== "v1" && s && s.res && (n.lng = this.language || s.usedLng), n.nest !== !1 && (e = this.interpolator.nest(e, function() {
        for (var c = arguments.length, f = new Array(c), p = 0; p < c; p++)
          f[p] = arguments[p];
        return r && r[0] === f[0] && !n.context ? (a.logger.warn(`It seems you are nesting recursively key: ${f[0]} in key: ${t[0]}`), null) : a.translate(...f, t);
      }, n)), n.interpolation && this.interpolator.reset();
    }
    const o = n.postProcess || this.options.postProcess, l = d(o) ? [o] : o;
    return e != null && l && l.length && n.applyPostProcessor !== !1 && (e = Ve.handle(l, e, t, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...s,
        usedParams: this.getUsedParamsDetails(n)
      },
      ...n
    } : n, this)), e;
  }
  resolve(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n, s, r, a, o;
    return d(e) && (e = [e]), e.forEach((l) => {
      if (this.isValidLookup(n))
        return;
      const u = this.extractFromKey(l, t), h = u.key;
      s = h;
      let g = u.namespaces;
      this.options.fallbackNS && (g = g.concat(this.options.fallbackNS));
      const c = t.count !== void 0 && !d(t.count), f = c && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), p = t.context !== void 0 && (d(t.context) || typeof t.context == "number") && t.context !== "", b = t.lngs ? t.lngs : this.languageUtils.toResolveHierarchy(t.lng || this.language, t.fallbackLng);
      g.forEach((m) => {
        this.isValidLookup(n) || (o = m, !xe[`${b[0]}-${m}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(o) && (xe[`${b[0]}-${m}`] = !0, this.logger.warn(`key "${s}" for languages "${b.join(", ")}" won't get resolved as namespace "${o}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), b.forEach((w) => {
          if (this.isValidLookup(n))
            return;
          a = w;
          const x = [h];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(x, h, w, m, t);
          else {
            let y;
            c && (y = this.pluralResolver.getSuffix(w, t.count, t));
            const k = `${this.options.pluralSeparator}zero`, I = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (c && (x.push(h + y), t.ordinal && y.indexOf(I) === 0 && x.push(h + y.replace(I, this.options.pluralSeparator)), f && x.push(h + k)), p) {
              const S = `${h}${this.options.contextSeparator}${t.context}`;
              x.push(S), c && (x.push(S + y), t.ordinal && y.indexOf(I) === 0 && x.push(S + y.replace(I, this.options.pluralSeparator)), f && x.push(S + k));
            }
          }
          let R;
          for (; R = x.pop(); )
            this.isValidLookup(n) || (r = R, n = this.getResource(w, m, R, t));
        }));
      });
    }), {
      res: n,
      usedKey: s,
      exactUsedKey: r,
      usedLng: a,
      usedNS: o
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, t, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, t, n, s) : this.resourceStore.getResource(e, t, n, s);
  }
  getUsedParamsDetails() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const t = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], n = e.replace && !d(e.replace);
    let s = n ? e.replace : e;
    if (n && typeof e.count < "u" && (s.count = e.count), this.options.interpolation.defaultVariables && (s = {
      ...this.options.interpolation.defaultVariables,
      ...s
    }), !n) {
      s = {
        ...s
      };
      for (const r of t)
        delete s[r];
    }
    return s;
  }
  static hasDefaultValue(e) {
    const t = "defaultValue";
    for (const n in e)
      if (Object.prototype.hasOwnProperty.call(e, n) && t === n.substring(0, t.length) && e[n] !== void 0)
        return !0;
    return !1;
  }
}
const ee = (i) => i.charAt(0).toUpperCase() + i.slice(1);
class Se {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = $.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = Z(e), !e || e.indexOf("-") < 0)
      return null;
    const t = e.split("-");
    return t.length === 2 || (t.pop(), t[t.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(t.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = Z(e), !e || e.indexOf("-") < 0)
      return e;
    const t = e.split("-");
    return this.formatLanguageCode(t[0]);
  }
  formatLanguageCode(e) {
    if (d(e) && e.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let s = Intl.getCanonicalLocales(e)[0];
          if (s && this.options.lowerCaseLng && (s = s.toLowerCase()), s)
            return s;
        } catch {
        }
      const t = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let n = e.split("-");
      return this.options.lowerCaseLng ? n = n.map((s) => s.toLowerCase()) : n.length === 2 ? (n[0] = n[0].toLowerCase(), n[1] = n[1].toUpperCase(), t.indexOf(n[1].toLowerCase()) > -1 && (n[1] = ee(n[1].toLowerCase()))) : n.length === 3 && (n[0] = n[0].toLowerCase(), n[1].length === 2 && (n[1] = n[1].toUpperCase()), n[0] !== "sgn" && n[2].length === 2 && (n[2] = n[2].toUpperCase()), t.indexOf(n[1].toLowerCase()) > -1 && (n[1] = ee(n[1].toLowerCase())), t.indexOf(n[2].toLowerCase()) > -1 && (n[2] = ee(n[2].toLowerCase()))), n.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e)
      return null;
    let t;
    return e.forEach((n) => {
      if (t)
        return;
      const s = this.formatLanguageCode(n);
      (!this.options.supportedLngs || this.isSupportedCode(s)) && (t = s);
    }), !t && this.options.supportedLngs && e.forEach((n) => {
      if (t)
        return;
      const s = this.getLanguagePartFromCode(n);
      if (this.isSupportedCode(s))
        return t = s;
      t = this.options.supportedLngs.find((r) => {
        if (r === s)
          return r;
        if (!(r.indexOf("-") < 0 && s.indexOf("-") < 0) && (r.indexOf("-") > 0 && s.indexOf("-") < 0 && r.substring(0, r.indexOf("-")) === s || r.indexOf(s) === 0 && s.length > 1))
          return r;
      });
    }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t;
  }
  getFallbackCodes(e, t) {
    if (!e)
      return [];
    if (typeof e == "function" && (e = e(t)), d(e) && (e = [e]), Array.isArray(e))
      return e;
    if (!t)
      return e.default || [];
    let n = e[t];
    return n || (n = e[this.getScriptPartFromCode(t)]), n || (n = e[this.formatLanguageCode(t)]), n || (n = e[this.getLanguagePartFromCode(t)]), n || (n = e.default), n || [];
  }
  toResolveHierarchy(e, t) {
    const n = this.getFallbackCodes(t || this.options.fallbackLng || [], e), s = [], r = (a) => {
      a && (this.isSupportedCode(a) ? s.push(a) : this.logger.warn(`rejecting language code not found in supportedLngs: ${a}`));
    };
    return d(e) && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && r(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && r(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && r(this.getLanguagePartFromCode(e))) : d(e) && r(this.formatLanguageCode(e)), n.forEach((a) => {
      s.indexOf(a) < 0 && r(this.formatLanguageCode(a));
    }), s;
  }
}
let $t = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], At = {
  1: (i) => +(i > 1),
  2: (i) => +(i != 1),
  3: (i) => 0,
  4: (i) => i % 10 == 1 && i % 100 != 11 ? 0 : i % 10 >= 2 && i % 10 <= 4 && (i % 100 < 10 || i % 100 >= 20) ? 1 : 2,
  5: (i) => i == 0 ? 0 : i == 1 ? 1 : i == 2 ? 2 : i % 100 >= 3 && i % 100 <= 10 ? 3 : i % 100 >= 11 ? 4 : 5,
  6: (i) => i == 1 ? 0 : i >= 2 && i <= 4 ? 1 : 2,
  7: (i) => i == 1 ? 0 : i % 10 >= 2 && i % 10 <= 4 && (i % 100 < 10 || i % 100 >= 20) ? 1 : 2,
  8: (i) => i == 1 ? 0 : i == 2 ? 1 : i != 8 && i != 11 ? 2 : 3,
  9: (i) => +(i >= 2),
  10: (i) => i == 1 ? 0 : i == 2 ? 1 : i < 7 ? 2 : i < 11 ? 3 : 4,
  11: (i) => i == 1 || i == 11 ? 0 : i == 2 || i == 12 ? 1 : i > 2 && i < 20 ? 2 : 3,
  12: (i) => +(i % 10 != 1 || i % 100 == 11),
  13: (i) => +(i !== 0),
  14: (i) => i == 1 ? 0 : i == 2 ? 1 : i == 3 ? 2 : 3,
  15: (i) => i % 10 == 1 && i % 100 != 11 ? 0 : i % 10 >= 2 && (i % 100 < 10 || i % 100 >= 20) ? 1 : 2,
  16: (i) => i % 10 == 1 && i % 100 != 11 ? 0 : i !== 0 ? 1 : 2,
  17: (i) => i == 1 || i % 10 == 1 && i % 100 != 11 ? 0 : 1,
  18: (i) => i == 0 ? 0 : i == 1 ? 1 : 2,
  19: (i) => i == 1 ? 0 : i == 0 || i % 100 > 1 && i % 100 < 11 ? 1 : i % 100 > 10 && i % 100 < 20 ? 2 : 3,
  20: (i) => i == 1 ? 0 : i == 0 || i % 100 > 0 && i % 100 < 20 ? 1 : 2,
  21: (i) => i % 100 == 1 ? 1 : i % 100 == 2 ? 2 : i % 100 == 3 || i % 100 == 4 ? 3 : 0,
  22: (i) => i == 1 ? 0 : i == 2 ? 1 : (i < 0 || i > 10) && i % 10 == 0 ? 2 : 3
};
const Ft = ["v1", "v2", "v3"], Et = ["v4"], ve = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, jt = () => {
  const i = {};
  return $t.forEach((e) => {
    e.lngs.forEach((t) => {
      i[t] = {
        numbers: e.nr,
        plurals: At[e.fc]
      };
    });
  }), i;
};
class Dt {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = e, this.options = t, this.logger = $.create("pluralResolver"), (!this.options.compatibilityJSON || Et.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = jt(), this.pluralRulesCache = {};
  }
  addRule(e, t) {
    this.rules[e] = t;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi())
      try {
        const n = Z(e === "dev" ? "en" : e), s = t.ordinal ? "ordinal" : "cardinal", r = JSON.stringify({
          cleanedCode: n,
          type: s
        });
        if (r in this.pluralRulesCache)
          return this.pluralRulesCache[r];
        const a = new Intl.PluralRules(n, {
          type: s
        });
        return this.pluralRulesCache[r] = a, a;
      } catch {
        return;
      }
    return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
  }
  needsPlural(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const n = this.getRule(e, t);
    return this.shouldUseIntlApi() ? n && n.resolvedOptions().pluralCategories.length > 1 : n && n.numbers.length > 1;
  }
  getPluralFormsOfKey(e, t) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(e, n).map((s) => `${t}${s}`);
  }
  getSuffixes(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const n = this.getRule(e, t);
    return n ? this.shouldUseIntlApi() ? n.resolvedOptions().pluralCategories.sort((s, r) => ve[s] - ve[r]).map((s) => `${this.options.prepend}${t.ordinal ? `ordinal${this.options.prepend}` : ""}${s}`) : n.numbers.map((s) => this.getSuffix(e, s, t)) : [];
  }
  getSuffix(e, t) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const s = this.getRule(e, n);
    return s ? this.shouldUseIntlApi() ? `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${s.select(t)}` : this.getSuffixRetroCompatible(s, t) : (this.logger.warn(`no plural rule found for: ${e}`), "");
  }
  getSuffixRetroCompatible(e, t) {
    const n = e.noAbs ? e.plurals(t) : e.plurals(Math.abs(t));
    let s = e.numbers[n];
    this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 && (s === 2 ? s = "plural" : s === 1 && (s = ""));
    const r = () => this.options.prepend && s.toString() ? this.options.prepend + s.toString() : s.toString();
    return this.options.compatibilityJSON === "v1" ? s === 1 ? "" : typeof s == "number" ? `_plural_${s.toString()}` : r() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 ? r() : this.options.prepend && n.toString() ? this.options.prepend + n.toString() : n.toString();
  }
  shouldUseIntlApi() {
    return !Ft.includes(this.options.compatibilityJSON);
  }
}
const we = function(i, e, t) {
  let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, r = Lt(i, e, t);
  return !r && s && d(t) && (r = oe(i, t, n), r === void 0 && (r = oe(e, t, n))), r;
}, te = (i) => i.replace(/\$/g, "$$$$");
class Vt {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = $.create("interpolator"), this.options = e, this.format = e.interpolation && e.interpolation.format || ((t) => t), this.init(e);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: t,
      escapeValue: n,
      useRawValueToEscape: s,
      prefix: r,
      prefixEscaped: a,
      suffix: o,
      suffixEscaped: l,
      formatSeparator: u,
      unescapeSuffix: h,
      unescapePrefix: g,
      nestingPrefix: c,
      nestingPrefixEscaped: f,
      nestingSuffix: p,
      nestingSuffixEscaped: b,
      nestingOptionsSeparator: m,
      maxReplaces: w,
      alwaysFormat: x
    } = e.interpolation;
    this.escape = t !== void 0 ? t : Nt, this.escapeValue = n !== void 0 ? n : !0, this.useRawValueToEscape = s !== void 0 ? s : !1, this.prefix = r ? E(r) : a || "{{", this.suffix = o ? E(o) : l || "}}", this.formatSeparator = u || ",", this.unescapePrefix = h ? "" : g || "-", this.unescapeSuffix = this.unescapePrefix ? "" : h || "", this.nestingPrefix = c ? E(c) : f || E("$t("), this.nestingSuffix = p ? E(p) : b || E(")"), this.nestingOptionsSeparator = m || ",", this.maxReplaces = w || 1e3, this.alwaysFormat = x !== void 0 ? x : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (t, n) => t && t.source === n ? (t.lastIndex = 0, t) : new RegExp(n, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e, t, n, s) {
    let r, a, o;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, u = (f) => {
      if (f.indexOf(this.formatSeparator) < 0) {
        const w = we(t, l, f, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(w, void 0, n, {
          ...s,
          ...t,
          interpolationkey: f
        }) : w;
      }
      const p = f.split(this.formatSeparator), b = p.shift().trim(), m = p.join(this.formatSeparator).trim();
      return this.format(we(t, l, b, this.options.keySeparator, this.options.ignoreJSONStructure), m, n, {
        ...s,
        ...t,
        interpolationkey: b
      });
    };
    this.resetRegExp();
    const h = s && s.missingInterpolationHandler || this.options.missingInterpolationHandler, g = s && s.interpolation && s.interpolation.skipOnVariables !== void 0 ? s.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (f) => te(f)
    }, {
      regex: this.regexp,
      safeValue: (f) => this.escapeValue ? te(this.escape(f)) : te(f)
    }].forEach((f) => {
      for (o = 0; r = f.regex.exec(e); ) {
        const p = r[1].trim();
        if (a = u(p), a === void 0)
          if (typeof h == "function") {
            const m = h(e, r, s);
            a = d(m) ? m : "";
          } else if (s && Object.prototype.hasOwnProperty.call(s, p))
            a = "";
          else if (g) {
            a = r[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${p} for interpolating ${e}`), a = "";
        else
          !d(a) && !this.useRawValueToEscape && (a = de(a));
        const b = f.safeValue(a);
        if (e = e.replace(r[0], b), g ? (f.regex.lastIndex += a.length, f.regex.lastIndex -= r[0].length) : f.regex.lastIndex = 0, o++, o >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, t) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s, r, a;
    const o = (l, u) => {
      const h = this.nestingOptionsSeparator;
      if (l.indexOf(h) < 0)
        return l;
      const g = l.split(new RegExp(`${h}[ ]*{`));
      let c = `{${g[1]}`;
      l = g[0], c = this.interpolate(c, a);
      const f = c.match(/'/g), p = c.match(/"/g);
      (f && f.length % 2 === 0 && !p || p.length % 2 !== 0) && (c = c.replace(/'/g, '"'));
      try {
        a = JSON.parse(c), u && (a = {
          ...u,
          ...a
        });
      } catch (b) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, b), `${l}${h}${c}`;
      }
      return a.defaultValue && a.defaultValue.indexOf(this.prefix) > -1 && delete a.defaultValue, l;
    };
    for (; s = this.nestingRegexp.exec(e); ) {
      let l = [];
      a = {
        ...n
      }, a = a.replace && !d(a.replace) ? a.replace : a, a.applyPostProcessor = !1, delete a.defaultValue;
      let u = !1;
      if (s[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(s[1])) {
        const h = s[1].split(this.formatSeparator).map((g) => g.trim());
        s[1] = h.shift(), l = h, u = !0;
      }
      if (r = t(o.call(this, s[1].trim(), a), a), r && s[0] === e && !d(r))
        return r;
      d(r) || (r = de(r)), r || (this.logger.warn(`missed to resolve ${s[1]} for nesting ${e}`), r = ""), u && (r = l.reduce((h, g) => this.format(h, g, n.lng, {
        ...n,
        interpolationkey: s[1].trim()
      }), r.trim())), e = e.replace(s[0], r), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
const Mt = (i) => {
  let e = i.toLowerCase().trim();
  const t = {};
  if (i.indexOf("(") > -1) {
    const n = i.split("(");
    e = n[0].toLowerCase().trim();
    const s = n[1].substring(0, n[1].length - 1);
    e === "currency" && s.indexOf(":") < 0 ? t.currency || (t.currency = s.trim()) : e === "relativetime" && s.indexOf(":") < 0 ? t.range || (t.range = s.trim()) : s.split(";").forEach((a) => {
      if (a) {
        const [o, ...l] = a.split(":"), u = l.join(":").trim().replace(/^'+|'+$/g, ""), h = o.trim();
        t[h] || (t[h] = u), u === "false" && (t[h] = !1), u === "true" && (t[h] = !0), isNaN(u) || (t[h] = parseInt(u, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: t
  };
}, j = (i) => {
  const e = {};
  return (t, n, s) => {
    let r = s;
    s && s.interpolationkey && s.formatParams && s.formatParams[s.interpolationkey] && s[s.interpolationkey] && (r = {
      ...r,
      [s.interpolationkey]: void 0
    });
    const a = n + JSON.stringify(r);
    let o = e[a];
    return o || (o = i(Z(n), s), e[a] = o), o(t);
  };
};
class Ut {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = $.create("formatter"), this.options = e, this.formats = {
      number: j((t, n) => {
        const s = new Intl.NumberFormat(t, {
          ...n
        });
        return (r) => s.format(r);
      }),
      currency: j((t, n) => {
        const s = new Intl.NumberFormat(t, {
          ...n,
          style: "currency"
        });
        return (r) => s.format(r);
      }),
      datetime: j((t, n) => {
        const s = new Intl.DateTimeFormat(t, {
          ...n
        });
        return (r) => s.format(r);
      }),
      relativetime: j((t, n) => {
        const s = new Intl.RelativeTimeFormat(t, {
          ...n
        });
        return (r) => s.format(r, n.range || "day");
      }),
      list: j((t, n) => {
        const s = new Intl.ListFormat(t, {
          ...n
        });
        return (r) => s.format(r);
      })
    }, this.init(e);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = t.interpolation.formatSeparator || ",";
  }
  add(e, t) {
    this.formats[e.toLowerCase().trim()] = t;
  }
  addCached(e, t) {
    this.formats[e.toLowerCase().trim()] = j(t);
  }
  format(e, t, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const r = t.split(this.formatSeparator);
    if (r.length > 1 && r[0].indexOf("(") > 1 && r[0].indexOf(")") < 0 && r.find((o) => o.indexOf(")") > -1)) {
      const o = r.findIndex((l) => l.indexOf(")") > -1);
      r[0] = [r[0], ...r.splice(1, o)].join(this.formatSeparator);
    }
    return r.reduce((o, l) => {
      const {
        formatName: u,
        formatOptions: h
      } = Mt(l);
      if (this.formats[u]) {
        let g = o;
        try {
          const c = s && s.formatParams && s.formatParams[s.interpolationkey] || {}, f = c.locale || c.lng || s.locale || s.lng || n;
          g = this.formats[u](o, f, {
            ...h,
            ...s,
            ...c
          });
        } catch (c) {
          this.logger.warn(c);
        }
        return g;
      } else
        this.logger.warn(`there was no format function for ${u}`);
      return o;
    }, e);
  }
}
const Kt = (i, e) => {
  i.pending[e] !== void 0 && (delete i.pending[e], i.pendingCount--);
};
class Bt extends _ {
  constructor(e, t, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = e, this.store = t, this.services = n, this.languageUtils = n.languageUtils, this.options = s, this.logger = $.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = s.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = s.maxRetries >= 0 ? s.maxRetries : 5, this.retryTimeout = s.retryTimeout >= 1 ? s.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(n, s.backend, s);
  }
  queueLoad(e, t, n, s) {
    const r = {}, a = {}, o = {}, l = {};
    return e.forEach((u) => {
      let h = !0;
      t.forEach((g) => {
        const c = `${u}|${g}`;
        !n.reload && this.store.hasResourceBundle(u, g) ? this.state[c] = 2 : this.state[c] < 0 || (this.state[c] === 1 ? a[c] === void 0 && (a[c] = !0) : (this.state[c] = 1, h = !1, a[c] === void 0 && (a[c] = !0), r[c] === void 0 && (r[c] = !0), l[g] === void 0 && (l[g] = !0)));
      }), h || (o[u] = !0);
    }), (Object.keys(r).length || Object.keys(a).length) && this.queue.push({
      pending: a,
      pendingCount: Object.keys(a).length,
      loaded: {},
      errors: [],
      callback: s
    }), {
      toLoad: Object.keys(r),
      pending: Object.keys(a),
      toLoadLanguages: Object.keys(o),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(e, t, n) {
    const s = e.split("|"), r = s[0], a = s[1];
    t && this.emit("failedLoading", r, a, t), !t && n && this.store.addResourceBundle(r, a, n, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = t ? -1 : 2, t && n && (this.state[e] = 0);
    const o = {};
    this.queue.forEach((l) => {
      kt(l.loaded, [r], a), Kt(l, e), t && l.errors.push(t), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((u) => {
        o[u] || (o[u] = {});
        const h = l.loaded[u];
        h.length && h.forEach((g) => {
          o[u][g] === void 0 && (o[u][g] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", o), this.queue = this.queue.filter((l) => !l.done);
  }
  read(e, t, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, r = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, a = arguments.length > 5 ? arguments[5] : void 0;
    if (!e.length)
      return a(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: t,
        fcName: n,
        tried: s,
        wait: r,
        callback: a
      });
      return;
    }
    this.readingCalls++;
    const o = (u, h) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const g = this.waitingReads.shift();
        this.read(g.lng, g.ns, g.fcName, g.tried, g.wait, g.callback);
      }
      if (u && h && s < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, t, n, s + 1, r * 2, a);
        }, r);
        return;
      }
      a(u, h);
    }, l = this.backend[n].bind(this.backend);
    if (l.length === 2) {
      try {
        const u = l(e, t);
        u && typeof u.then == "function" ? u.then((h) => o(null, h)).catch(o) : o(null, u);
      } catch (u) {
        o(u);
      }
      return;
    }
    return l(e, t, o);
  }
  prepareLoading(e, t) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), s && s();
    d(e) && (e = this.languageUtils.toResolveHierarchy(e)), d(t) && (t = [t]);
    const r = this.queueLoad(e, t, n, s);
    if (!r.toLoad.length)
      return r.pending.length || s(), null;
    r.toLoad.forEach((a) => {
      this.loadOne(a);
    });
  }
  load(e, t, n) {
    this.prepareLoading(e, t, {}, n);
  }
  reload(e, t, n) {
    this.prepareLoading(e, t, {
      reload: !0
    }, n);
  }
  loadOne(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const n = e.split("|"), s = n[0], r = n[1];
    this.read(s, r, "read", void 0, void 0, (a, o) => {
      a && this.logger.warn(`${t}loading namespace ${r} for language ${s} failed`, a), !a && o && this.logger.log(`${t}loaded namespace ${r} for language ${s}`, o), this.loaded(e, a, o);
    });
  }
  saveMissing(e, t, n, s, r) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(t)) {
      this.logger.warn(`did not save key "${n}" as the namespace "${t}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(n == null || n === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...a,
          isUpdate: r
        }, u = this.backend.create.bind(this.backend);
        if (u.length < 6)
          try {
            let h;
            u.length === 5 ? h = u(e, t, n, s, l) : h = u(e, t, n, s), h && typeof h.then == "function" ? h.then((g) => o(null, g)).catch(o) : o(null, h);
          } catch (h) {
            o(h);
          }
        else
          u(e, t, n, s, o, l);
      }
      !e || !e[0] || this.store.addResource(e[0], t, n, s);
    }
  }
}
const ke = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (i) => {
    let e = {};
    if (typeof i[1] == "object" && (e = i[1]), d(i[1]) && (e.defaultValue = i[1]), d(i[2]) && (e.tDescription = i[2]), typeof i[2] == "object" || typeof i[3] == "object") {
      const t = i[3] || i[2];
      Object.keys(t).forEach((n) => {
        e[n] = t[n];
      });
    }
    return e;
  },
  interpolation: {
    escapeValue: !0,
    format: (i) => i,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), Le = (i) => (d(i.ns) && (i.ns = [i.ns]), d(i.fallbackLng) && (i.fallbackLng = [i.fallbackLng]), d(i.fallbackNS) && (i.fallbackNS = [i.fallbackNS]), i.supportedLngs && i.supportedLngs.indexOf("cimode") < 0 && (i.supportedLngs = i.supportedLngs.concat(["cimode"])), i), W = () => {
}, Gt = (i) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(i)).forEach((t) => {
    typeof i[t] == "function" && (i[t] = i[t].bind(i));
  });
};
class J extends _ {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = Le(e), this.services = {}, this.logger = $, this.modules = {
      external: []
    }, Gt(this), t && !this.isInitialized && !e.isClone) {
      if (!this.options.initImmediate)
        return this.init(e, t), this;
      setTimeout(() => {
        this.init(e, t);
      }, 0);
    }
  }
  init() {
    var e = this;
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof t == "function" && (n = t, t = {}), !t.defaultNS && t.defaultNS !== !1 && t.ns && (d(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const s = ke();
    this.options = {
      ...s,
      ...this.options,
      ...Le(t)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...s.interpolation,
      ...this.options.interpolation
    }), t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const r = (h) => h ? typeof h == "function" ? new h() : h : null;
    if (!this.options.isClone) {
      this.modules.logger ? $.init(r(this.modules.logger), this.options) : $.init(null, this.options);
      let h;
      this.modules.formatter ? h = this.modules.formatter : typeof Intl < "u" && (h = Ut);
      const g = new Se(this.options);
      this.store = new ye(this.options.resources, this.options);
      const c = this.services;
      c.logger = $, c.resourceStore = this.store, c.languageUtils = g, c.pluralResolver = new Dt(g, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), h && (!this.options.interpolation.format || this.options.interpolation.format === s.interpolation.format) && (c.formatter = r(h), c.formatter.init(c, this.options), this.options.interpolation.format = c.formatter.format.bind(c.formatter)), c.interpolator = new Vt(this.options), c.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, c.backendConnector = new Bt(r(this.modules.backend), c.resourceStore, c, this.options), c.backendConnector.on("*", function(f) {
        for (var p = arguments.length, b = new Array(p > 1 ? p - 1 : 0), m = 1; m < p; m++)
          b[m - 1] = arguments[m];
        e.emit(f, ...b);
      }), this.modules.languageDetector && (c.languageDetector = r(this.modules.languageDetector), c.languageDetector.init && c.languageDetector.init(c, this.options.detection, this.options)), this.modules.i18nFormat && (c.i18nFormat = r(this.modules.i18nFormat), c.i18nFormat.init && c.i18nFormat.init(this)), this.translator = new q(this.services, this.options), this.translator.on("*", function(f) {
        for (var p = arguments.length, b = new Array(p > 1 ? p - 1 : 0), m = 1; m < p; m++)
          b[m - 1] = arguments[m];
        e.emit(f, ...b);
      }), this.modules.external.forEach((f) => {
        f.init && f.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, n || (n = W), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const h = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      h.length > 0 && h[0] !== "dev" && (this.options.lng = h[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((h) => {
      this[h] = function() {
        return e.store[h](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((h) => {
      this[h] = function() {
        return e.store[h](...arguments), e;
      };
    });
    const l = K(), u = () => {
      const h = (g, c) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(c), n(g, c);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return h(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, h);
    };
    return this.options.resources || !this.options.initImmediate ? u() : setTimeout(u, 0), l;
  }
  loadResources(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : W;
    const s = d(e) ? e : this.language;
    if (typeof e == "function" && (n = e), !this.options.resources || this.options.partialBundledLanguages) {
      if (s && s.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return n();
      const r = [], a = (o) => {
        if (!o || o === "cimode")
          return;
        this.services.languageUtils.toResolveHierarchy(o).forEach((u) => {
          u !== "cimode" && r.indexOf(u) < 0 && r.push(u);
        });
      };
      s ? a(s) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => a(l)), this.options.preload && this.options.preload.forEach((o) => a(o)), this.services.backendConnector.load(r, this.options.ns, (o) => {
        !o && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), n(o);
      });
    } else
      n(null);
  }
  reloadResources(e, t, n) {
    const s = K();
    return typeof e == "function" && (n = e, e = void 0), typeof t == "function" && (n = t, t = void 0), e || (e = this.languages), t || (t = this.options.ns), n || (n = W), this.services.backendConnector.reload(e, t, (r) => {
      s.resolve(), n(r);
    }), s;
  }
  use(e) {
    if (!e)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && Ve.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1))
      for (let t = 0; t < this.languages.length; t++) {
        const n = this.languages[t];
        if (!(["cimode", "dev"].indexOf(n) > -1) && this.store.hasLanguageSomeTranslations(n)) {
          this.resolvedLanguage = n;
          break;
        }
      }
  }
  changeLanguage(e, t) {
    var n = this;
    this.isLanguageChangingTo = e;
    const s = K();
    this.emit("languageChanging", e);
    const r = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, a = (l, u) => {
      u ? (r(u), this.translator.changeLanguage(u), this.isLanguageChangingTo = void 0, this.emit("languageChanged", u), this.logger.log("languageChanged", u)) : this.isLanguageChangingTo = void 0, s.resolve(function() {
        return n.t(...arguments);
      }), t && t(l, function() {
        return n.t(...arguments);
      });
    }, o = (l) => {
      !e && !l && this.services.languageDetector && (l = []);
      const u = d(l) ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      u && (this.language || r(u), this.translator.language || this.translator.changeLanguage(u), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(u)), this.loadResources(u, (h) => {
        a(h, u);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? o(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(o) : this.services.languageDetector.detect(o) : o(e), s;
  }
  getFixedT(e, t, n) {
    var s = this;
    const r = function(a, o) {
      let l;
      if (typeof o != "object") {
        for (var u = arguments.length, h = new Array(u > 2 ? u - 2 : 0), g = 2; g < u; g++)
          h[g - 2] = arguments[g];
        l = s.options.overloadTranslationOptionHandler([a, o].concat(h));
      } else
        l = {
          ...o
        };
      l.lng = l.lng || r.lng, l.lngs = l.lngs || r.lngs, l.ns = l.ns || r.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || n || r.keyPrefix);
      const c = s.options.keySeparator || ".";
      let f;
      return l.keyPrefix && Array.isArray(a) ? f = a.map((p) => `${l.keyPrefix}${c}${p}`) : f = l.keyPrefix ? `${l.keyPrefix}${c}${a}` : a, s.t(f, l);
    };
    return d(e) ? r.lng = e : r.lngs = e, r.ns = t, r.keyPrefix = n, r;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const n = t.lng || this.resolvedLanguage || this.languages[0], s = this.options ? this.options.fallbackLng : !1, r = this.languages[this.languages.length - 1];
    if (n.toLowerCase() === "cimode")
      return !0;
    const a = (o, l) => {
      const u = this.services.backendConnector.state[`${o}|${l}`];
      return u === -1 || u === 0 || u === 2;
    };
    if (t.precheck) {
      const o = t.precheck(this, a);
      if (o !== void 0)
        return o;
    }
    return !!(this.hasResourceBundle(n, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || a(n, e) && (!s || a(r, e)));
  }
  loadNamespaces(e, t) {
    const n = K();
    return this.options.ns ? (d(e) && (e = [e]), e.forEach((s) => {
      this.options.ns.indexOf(s) < 0 && this.options.ns.push(s);
    }), this.loadResources((s) => {
      n.resolve(), t && t(s);
    }), n) : (t && t(), Promise.resolve());
  }
  loadLanguages(e, t) {
    const n = K();
    d(e) && (e = [e]);
    const s = this.options.preload || [], r = e.filter((a) => s.indexOf(a) < 0 && this.services.languageUtils.isSupportedCode(a));
    return r.length ? (this.options.preload = s.concat(r), this.loadResources((a) => {
      n.resolve(), t && t(a);
    }), n) : (t && t(), Promise.resolve());
  }
  dir(e) {
    if (e || (e = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !e)
      return "rtl";
    const t = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], n = this.services && this.services.languageUtils || new Se(ke());
    return t.indexOf(n.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    return new J(e, t);
  }
  cloneInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : W;
    const n = e.forkResourceStore;
    n && delete e.forkResourceStore;
    const s = {
      ...this.options,
      ...e,
      isClone: !0
    }, r = new J(s);
    return (e.debug !== void 0 || e.prefix !== void 0) && (r.logger = r.logger.clone(e)), ["store", "services", "language"].forEach((o) => {
      r[o] = this[o];
    }), r.services = {
      ...this.services
    }, r.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, n && (r.store = new ye(this.store.data, s), r.services.resourceStore = r.store), r.translator = new q(r.services, s), r.translator.on("*", function(o) {
      for (var l = arguments.length, u = new Array(l > 1 ? l - 1 : 0), h = 1; h < l; h++)
        u[h - 1] = arguments[h];
      r.emit(o, ...u);
    }), r.init(s, t), r.translator.options = s, r.translator.backendConnector.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, r;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const L = J.createInstance();
L.createInstance = J.createInstance;
L.createInstance;
L.dir;
L.init;
L.loadResources;
L.reloadResources;
L.use;
L.changeLanguage;
L.getFixedT;
L.t;
L.exists;
L.setDefaultNamespace;
L.hasLoadedNamespace;
L.loadNamespaces;
L.loadLanguages;
const {
  slice: Ht,
  forEach: zt
} = [];
function Jt(i) {
  return zt.call(Ht.call(arguments, 1), (e) => {
    if (e)
      for (const t in e)
        i[t] === void 0 && (i[t] = e[t]);
  }), i;
}
const Ce = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/, Yt = (i, e, t) => {
  const n = t || {};
  n.path = n.path || "/";
  const s = encodeURIComponent(e);
  let r = `${i}=${s}`;
  if (n.maxAge > 0) {
    const a = n.maxAge - 0;
    if (Number.isNaN(a))
      throw new Error("maxAge should be a Number");
    r += `; Max-Age=${Math.floor(a)}`;
  }
  if (n.domain) {
    if (!Ce.test(n.domain))
      throw new TypeError("option domain is invalid");
    r += `; Domain=${n.domain}`;
  }
  if (n.path) {
    if (!Ce.test(n.path))
      throw new TypeError("option path is invalid");
    r += `; Path=${n.path}`;
  }
  if (n.expires) {
    if (typeof n.expires.toUTCString != "function")
      throw new TypeError("option expires is invalid");
    r += `; Expires=${n.expires.toUTCString()}`;
  }
  if (n.httpOnly && (r += "; HttpOnly"), n.secure && (r += "; Secure"), n.sameSite)
    switch (typeof n.sameSite == "string" ? n.sameSite.toLowerCase() : n.sameSite) {
      case !0:
        r += "; SameSite=Strict";
        break;
      case "lax":
        r += "; SameSite=Lax";
        break;
      case "strict":
        r += "; SameSite=Strict";
        break;
      case "none":
        r += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  return r;
}, Ne = {
  create(i, e, t, n) {
    let s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      path: "/",
      sameSite: "strict"
    };
    t && (s.expires = /* @__PURE__ */ new Date(), s.expires.setTime(s.expires.getTime() + t * 60 * 1e3)), n && (s.domain = n), document.cookie = Yt(i, encodeURIComponent(e), s);
  },
  read(i) {
    const e = `${i}=`, t = document.cookie.split(";");
    for (let n = 0; n < t.length; n++) {
      let s = t[n];
      for (; s.charAt(0) === " "; )
        s = s.substring(1, s.length);
      if (s.indexOf(e) === 0)
        return s.substring(e.length, s.length);
    }
    return null;
  },
  remove(i) {
    this.create(i, "", -1);
  }
};
var Wt = {
  name: "cookie",
  // Deconstruct the options object and extract the lookupCookie property
  lookup(i) {
    let {
      lookupCookie: e
    } = i;
    if (e && typeof document < "u")
      return Ne.read(e) || void 0;
  },
  // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
  cacheUserLanguage(i, e) {
    let {
      lookupCookie: t,
      cookieMinutes: n,
      cookieDomain: s,
      cookieOptions: r
    } = e;
    t && typeof document < "u" && Ne.create(t, i, n, s, r);
  }
}, Xt = {
  name: "querystring",
  // Deconstruct the options object and extract the lookupQuerystring property
  lookup(i) {
    var n;
    let {
      lookupQuerystring: e
    } = i, t;
    if (typeof window < "u") {
      let {
        search: s
      } = window.location;
      !window.location.search && ((n = window.location.hash) == null ? void 0 : n.indexOf("?")) > -1 && (s = window.location.hash.substring(window.location.hash.indexOf("?")));
      const a = s.substring(1).split("&");
      for (let o = 0; o < a.length; o++) {
        const l = a[o].indexOf("=");
        l > 0 && a[o].substring(0, l) === e && (t = a[o].substring(l + 1));
      }
    }
    return t;
  }
};
let B = null;
const Ie = () => {
  if (B !== null)
    return B;
  try {
    B = window !== "undefined" && window.localStorage !== null;
    const i = "i18next.translate.boo";
    window.localStorage.setItem(i, "foo"), window.localStorage.removeItem(i);
  } catch {
    B = !1;
  }
  return B;
};
var Zt = {
  name: "localStorage",
  // Deconstruct the options object and extract the lookupLocalStorage property
  lookup(i) {
    let {
      lookupLocalStorage: e
    } = i;
    if (e && Ie())
      return window.localStorage.getItem(e) || void 0;
  },
  // Deconstruct the options object and extract the lookupLocalStorage property
  cacheUserLanguage(i, e) {
    let {
      lookupLocalStorage: t
    } = e;
    t && Ie() && window.localStorage.setItem(t, i);
  }
};
let G = null;
const Oe = () => {
  if (G !== null)
    return G;
  try {
    G = window !== "undefined" && window.sessionStorage !== null;
    const i = "i18next.translate.boo";
    window.sessionStorage.setItem(i, "foo"), window.sessionStorage.removeItem(i);
  } catch {
    G = !1;
  }
  return G;
};
var Qt = {
  name: "sessionStorage",
  lookup(i) {
    let {
      lookupSessionStorage: e
    } = i;
    if (e && Oe())
      return window.sessionStorage.getItem(e) || void 0;
  },
  cacheUserLanguage(i, e) {
    let {
      lookupSessionStorage: t
    } = e;
    t && Oe() && window.sessionStorage.setItem(t, i);
  }
}, qt = {
  name: "navigator",
  lookup(i) {
    const e = [];
    if (typeof navigator < "u") {
      const {
        languages: t,
        userLanguage: n,
        language: s
      } = navigator;
      if (t)
        for (let r = 0; r < t.length; r++)
          e.push(t[r]);
      n && e.push(n), s && e.push(s);
    }
    return e.length > 0 ? e : void 0;
  }
}, _t = {
  name: "htmlTag",
  // Deconstruct the options object and extract the htmlTag property
  lookup(i) {
    let {
      htmlTag: e
    } = i, t;
    const n = e || (typeof document < "u" ? document.documentElement : null);
    return n && typeof n.getAttribute == "function" && (t = n.getAttribute("lang")), t;
  }
}, en = {
  name: "path",
  // Deconstruct the options object and extract the lookupFromPathIndex property
  lookup(i) {
    var s;
    let {
      lookupFromPathIndex: e
    } = i;
    if (typeof window > "u")
      return;
    const t = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
    return Array.isArray(t) ? (s = t[typeof e == "number" ? e : 0]) == null ? void 0 : s.replace("/", "") : void 0;
  }
}, tn = {
  name: "subdomain",
  lookup(i) {
    var s, r;
    let {
      lookupFromSubdomainIndex: e
    } = i;
    const t = typeof e == "number" ? e + 1 : 1, n = typeof window < "u" && ((r = (s = window.location) == null ? void 0 : s.hostname) == null ? void 0 : r.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i));
    if (n)
      return n[t];
  }
};
function nn() {
  return {
    order: ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"],
    lookupQuerystring: "lng",
    lookupCookie: "i18next",
    lookupLocalStorage: "i18nextLng",
    lookupSessionStorage: "i18nextLng",
    // cache user language
    caches: ["localStorage"],
    excludeCacheFor: ["cimode"],
    // cookieMinutes: 10,
    // cookieDomain: 'myDomain'
    convertDetectedLanguage: (i) => i
  };
}
class Me {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.type = "languageDetector", this.detectors = {}, this.init(e, t);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    this.services = e || {
      languageUtils: {}
    }, this.options = Jt(t, this.options || {}, nn()), typeof this.options.convertDetectedLanguage == "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1 && (this.options.convertDetectedLanguage = (s) => s.replace("-", "_")), this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex), this.i18nOptions = n, this.addDetector(Wt), this.addDetector(Xt), this.addDetector(Zt), this.addDetector(Qt), this.addDetector(qt), this.addDetector(_t), this.addDetector(en), this.addDetector(tn);
  }
  addDetector(e) {
    return this.detectors[e.name] = e, this;
  }
  detect(e) {
    e || (e = this.options.order);
    let t = [];
    return e.forEach((n) => {
      if (this.detectors[n]) {
        let s = this.detectors[n].lookup(this.options);
        s && typeof s == "string" && (s = [s]), s && (t = t.concat(s));
      }
    }), t = t.map((n) => this.options.convertDetectedLanguage(n)), this.services.languageUtils.getBestMatchFromCodes ? t : t.length > 0 ? t[0] : null;
  }
  cacheUserLanguage(e, t) {
    t || (t = this.options.caches), t && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(e) > -1 || t.forEach((n) => {
      this.detectors[n] && this.detectors[n].cacheUserLanguage(e, this.options);
    }));
  }
}
Me.type = "languageDetector";
const sn = {
  "(주)인프랩": "Inflab Co., Ltd.",
  "(주)인프랩 사업자 정보": "Inflab Co., Ltd. Business Information",
  "3동 5층": "Republic of Korea",
  "IT 인재 채용 서비스": "IT talents recruiting service",
  "MY 카테고리": "My category",
  "With us": "With us",
  "{{category.title}} > 전체": "{{category.title}} > All",
  "{{name}}님 인프런과 함께 해주셔서 감사해요. 😊": "{{name}}, thank you for being with Inflearn. 😊",
  "{{name}}님의 첫 도약을 응원하고 있어요. 🙌": "{{name}}, we’re cheering for your first step forward. 🙌",
  "{{name}}님의 커리어를 응원하고 있어요. 👏": "{{name}}, we’re cheering for your career growth. 👏",
  "{{profile?.name}}님의 프로필 이미지": "{{profile?.name}}’s profile image",
  "{{provider}}-로그인-버튼": "{{provider}}-Login-Button",
  "{{socialProviderNameMap[provider]}}로 로그인": "Log in with {{socialProviderNameMap[provider]}}",
  "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를": "With 'Inflearn Business,' you can provide an environment where all team members can",
  "가입 이메일 인증이 필요합니다.": "Email verification is required for registration.",
  "간편 로그인": "Social login",
  강의: "Course",
  "강의 · 기능요청": "Ask for course/function",
  "강의/강사명을 입력해주세요": "Enter the course/instructor name",
  "강의리스트 보기": "View course list",
  개: "ea",
  "개인정보보호책임자: 이동욱": "CPO: Lee Dongwook",
  개인정보처리방침: "Privacy Policy",
  "경기도 성남시 분당구 판교로289번길 20": "5F, Bldg #3, 20, Pangyo-ro 289beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do,",
  "경제적 보상을 받아보세요.": "and get financial rewards.",
  고객센터: "Customer Services",
  고민있어요: "I need help",
  공지사항: "Notice",
  교육: "Training",
  구글: "Google",
  "구매 내역": "Purchase history",
  국비지원교육: "Government-sponsored courses",
  기업: "Business",
  "기업 교육을 위한 인프런": "Inflearn for business education",
  깃허브: "GitHub",
  "나를 성장 시켜줄 좋은 지식들을 찾아보세요.": "Search for great pieces of knowledge that’ll help you grow.",
  "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요": "Find practical courses that can actually help you grow.",
  "남았어요.": "left.",
  "내 학습": "My learning",
  "네이버에서 구글 로그인을 지원하지 않습니다.": "Naver does not support Google Login.",
  "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.": "Please use a different mobile browser (Chrome, Safari).",
  닫기: "Close",
  "담긴 강의가 없습니다.": "No courses in cart.",
  대시보드: "Dashboard",
  "대표자: 이형주": "CEO: Lee Hyeongjoo",
  더보기: "More",
  "딱 맞는 강의가 기다리고 있어요.": "The perfect course for you awaits.",
  "랠릿 서비스 링크": "Rallit service link",
  로그아웃: "Log out",
  로그인: "Sign in",
  "로그인이 필요한 요청입니다.": "You need to log in to make this request.",
  로드맵: "Roadmap",
  "마음에 드는 강의를 수강해보세요!": "Take the course that draws your attention!",
  "많은 사람들에게 배움의 기회를 주고,": "Provide an opportunity to learn",
  "메인 페이지로 이동하기": "Go to main page",
  멘토링: "Mentoring",
  "멘토링 소개": "About mentoring",
  "멘토링 후기": "Mentoring Reviews",
  "모임/부트캠프": "Clubs/Bootcamp",
  "문제가 발생했습니다.": "An issue has occurred.",
  분: "min",
  블로그: "Blog",
  비밀번호: "Password",
  "비밀번호 찾기": "Find my password",
  "비밀번호를 입력해주세요.": "Enter your password.",
  비즈니스: "Business",
  "비즈니스 브랜드 로고": "Business brand logo",
  "비즈니스 수강내역": "Business course history",
  "사업자 정보 확인": "Check business information",
  "사업자번호: 499-81-00612": "Business Registration No.: 499-81-00612",
  "사용자 대시보드 페이지로 이동": "Go to user dashboard page",
  "사용자 알림 페이지로 이동": "Go to user notification page",
  서비스: "Service",
  "서비스 언어를 선택하세요.": "Select the service language.",
  설정: "Settings",
  수강바구니: "Cart",
  "수강바구니에서 전체보기": "Go to cart",
  "수강코드 등록": "Register course code",
  수강평: "Review",
  "수강평 모아보기": "See all reviews",
  "수료증 확인": "See certificate",
  스터디: "Study Clubs",
  시간: "hr",
  신청하기: "Apply",
  "아이디(이메일) 찾기": "Find my ID (email)",
  애플: "Apple",
  어드민: "Admin",
  "언어 설정": "Language Settings",
  원: "$",
  "유저 대시보드로 이동": "Go to user dashboard",
  "이 공지를 그만 볼래요": "Don't show me this notice",
  이메일: "Email",
  "이메일 또는 비밀번호를 확인해주세요.": "Check your email or password again.",
  "이메일 형식이 올바르지 않습니다.": "Invalid email format",
  "이메일을 입력해주세요.": "Enter your email.",
  "이어서 학습하기": "Continue learning",
  이용약관: "Terms of Use",
  인프랩: "Inflab",
  "인프랩 스토리": "Inflab story",
  "인프랩 실Log": "Inflab Log",
  "인프랩 테크": "Inflab tech",
  인프런: "Inflearn",
  "인프런 네이버 블로그 바로가기": "Go to Inflearn’s Naver blog",
  "인프런 네이버 포스트 바로가기": "Go to Inflearn’s Naver post",
  "인프런 메인 페이지로 이동": "Go to Inflearn main page",
  "인프런 브랜드 로고": "Inflearn brand logo",
  "인프런 비즈니스": "Inflearn business",
  "인프런 소개": "About Inflearn",
  "인프런 영문 브랜드 로고": "Inflearn English brand logo",
  "인프런 유튜브 바로가기": "Go to Inflearn’s YouTube channel",
  "인프런 인스타그램 바로가기": "Go to Inflearn’s Instagram",
  "인프런 제휴": "Inflearn partners",
  "인프런 통합 검색": "Search in Inflearn",
  "인프런 트위터 바로가기": "Go to Inflearn’s X (Twitter)",
  "인프런 페이스북 바로가기": "Go to Inflearn’s Facebook",
  "인프런 피드": "Inflearn feed",
  "인프런으로 이동하기": "Go to Inflearn",
  잎: "leaf",
  "자유롭게 학습하는 환경을 제공하세요.": "learn all they want through Inflearn’s courses.",
  "자주묻는 질문": "FAQ",
  "장바구니 페이지로 이동": "Go to cart page",
  "저작권 신고센터": "Report copyright issues",
  전체: "All",
  "전체 강의": "All courses",
  "전화번호: 070-4948-1181": "Phone: 070-4948-1181",
  좋아요: "Like",
  주소: "Address",
  "지금 둘러 보기": "Check out now",
  지식공유: "Teach",
  "지식공유 참여": "Teach on Inflearn",
  지식공유자: "Instructors",
  "지식공유자 되기": "Teach on Inflearn",
  지식공유참여: "Teach on Inflearn",
  "질문 & 답변": "QnA",
  "질문 게시판": "Questions",
  "채널톡 아이콘": "ChannelTalk icon",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "Something went wrong. Please try again later.",
  "청강대 게임스쿨": "Chungkang College Game School",
  초: "sec",
  "총 결제금액": "Total amount",
  "최근 강의 바로가기": "Go to recent course",
  "최근 로그인": "Recent login",
  카카오: "Kakao",
  "카카오톡에서 구글 로그인을 지원하지 않습니다.": "KakaoTalk does not support Google Login.",
  "카테고리 설정": "Set category",
  커리어: "Career",
  커뮤니티: "Community",
  "코드 등록": "Register Code",
  쿠폰: "Coupon",
  "통신판매업: 2018-성남분당B-0062": "E-Commerce Business: 2018-SeongnamBundangB-0062",
  "팀 프로젝트": "Team Projects",
  포인트: "Points",
  "포인트코드 등록": "Register point code",
  학생: "Student",
  "할인 종료까지": "Discount ends in",
  홈: "Home",
  확인: "OK",
  회원가입: "Sign up",
  "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 A surprise special thank-you discount has been applied to courses, so don’t wait and grab it now!",
  "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 A special discount for new members has been applied to courses, so don’t wait and grab it now!",
  "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 A surprise support discount has been applied to courses, so don’t wait and grab it now!"
}, rn = {
  "(주)인프랩": "株式会社インフラップ",
  "(주)인프랩 사업자 정보": "株式会社インフラップ事業者情報",
  "3동 5층": "3棟5階",
  "IT 인재 채용 서비스": "IT人材採用サービス",
  "MY 카테고리": "私のカテゴリ",
  "With us": "ウィズアス",
  "{{category.title}} > 전체": "{{category.title}} > 全体",
  "{{name}}님 인프런과 함께 해주셔서 감사해요. 😊": "{{name}}さん、インフランと一緒にいてくれてありがとう。😊",
  "{{name}}님의 첫 도약을 응원하고 있어요. 🙌": "{{name}}さんの初飛躍を応援しています。🙌",
  "{{name}}님의 커리어를 응원하고 있어요. 👏": "{{name}}さんのキャリアを応援しています。👏",
  "{{profile?.name}}님의 프로필 이미지": "{{profile?.name}}さんのプロフィール画像",
  "{{provider}}-로그인-버튼": "{{provider}}-ログイン-ボタン",
  "{{socialProviderNameMap[provider]}}로 로그인": "{{socialProviderNameMap[provider]}}でログイン",
  "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를": "「インフラントビジネス」を通じてすべてのチームメンバーがインフランの講義を",
  "가입 이메일 인증이 필요합니다.": "登録メールの認証が必要です。",
  "간편 로그인": "簡単ログイン",
  강의: "講義",
  "강의 · 기능요청": "講義・機能リクエスト",
  "강의/강사명을 입력해주세요": "講義/講師名を入力してください",
  "강의리스트 보기": "講義リストを見る",
  개: "個",
  "개인정보보호책임자: 이동욱": "個人情報保護責任者：イ・ドンウク",
  개인정보처리방침: "個人情報処理方針",
  "경기도 성남시 분당구 판교로289번길 20": "京畿道城南市盆唐区パンギョ路289番道20",
  "경제적 보상을 받아보세요.": "経済的な報酬を受け取ってください。",
  고객센터: "カスタマーセンター",
  고민있어요: "悩みがありますか",
  공지사항: "お知らせ",
  교육: "教育",
  구글: "グーグル",
  "구매 내역": "購入履歴",
  국비지원교육: "国費支援教育",
  기업: "企業",
  "기업 교육을 위한 인프런": "企業教育のためのインフラン",
  깃허브: "ギットハブ",
  "나를 성장 시켜줄 좋은 지식들을 찾아보세요.": "私を成長させてくれる良い知識を探してみてください。",
  "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요": "私の本当の成長を助ける実務講義を探してみてください",
  "남았어요.": "残っています。",
  "내 학습": "私の学習",
  "네이버에서 구글 로그인을 지원하지 않습니다.": "ネイバーではグーグルログインをサポートしていません。",
  "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.": "他のモバイルブラウザ（Chrome、Safari）をご利用ください。",
  닫기: "閉じる",
  "담긴 강의가 없습니다.": "含まれている講義はありません。",
  대시보드: "ダッシュボード",
  "대표자: 이형주": "代表者：イ・ヒョンジュ",
  더보기: "もっと見る",
  "딱 맞는 강의가 기다리고 있어요.": "ぴったりの講義が待っています。",
  "랠릿 서비스 링크": "レリットサービスリンク",
  로그아웃: "ログアウト",
  로그인: "ログイン",
  "로그인이 필요한 요청입니다.": "ログインが必要なリクエストです。",
  로드맵: "ロードマップ",
  "마음에 드는 강의를 수강해보세요!": "気に入った講義を受けてみてください！",
  "많은 사람들에게 배움의 기회를 주고,": "多くの人々に学習の機会を与え、",
  "메인 페이지로 이동하기": "メインページに移動する",
  멘토링: "メンタリング",
  "멘토링 소개": "メンタリング紹介",
  "멘토링 후기": "メンタリング後記",
  "모임/부트캠프": "集まり/ブートキャンプ",
  "문제가 발생했습니다.": "問題が発生しました。",
  분: "分",
  블로그: "ブログ",
  비밀번호: "パスワード",
  "비밀번호 찾기": "パスワード探し",
  "비밀번호를 입력해주세요.": "パスワードを入力してください。",
  비즈니스: "ビジネス",
  "비즈니스 브랜드 로고": "ビジネスブランドロゴ",
  "비즈니스 수강내역": "ビジネス受講履歴",
  "사업자 정보 확인": "事業者情報確認",
  "사업자번호: 499-81-00612": "事業者番号：499-81-00612",
  "사용자 대시보드 페이지로 이동": "ユーザーダッシュボードページに移動",
  "사용자 알림 페이지로 이동": "ユーザー通知ページに移動",
  서비스: "サービス",
  "서비스 언어를 선택하세요.": "サービス言語を選択してください。",
  설정: "設定",
  수강바구니: "受講カート",
  "수강바구니에서 전체보기": "受講カートで全体を見る",
  "수강코드 등록": "受講コード登録",
  수강평: "受講評価",
  "수강평 모아보기": "受講評価をまとめて見る",
  "수료증 확인": "修了証確認",
  스터디: "スタディ",
  시간: "時間",
  신청하기: "申し込む",
  "아이디(이메일) 찾기": "ID（メール）検索",
  애플: "アップル",
  어드민: "アドミン",
  "언어 설정": "言語設定",
  원: "ウォン",
  "유저 대시보드로 이동": "ユーザーダッシュボードに移動",
  "이 공지를 그만 볼래요": "この通知をもう見たくない",
  이메일: "メール",
  "이메일 또는 비밀번호를 확인해주세요.": "メールまたはパスワードを確認してください。",
  "이메일 형식이 올바르지 않습니다.": "メールアドレスの形式が正しくありません。",
  "이메일을 입력해주세요.": "メールを入力してください。",
  "이어서 학습하기": "続けて学習する",
  이용약관: "利用約款",
  인프랩: "インフラップ",
  "인프랩 스토리": "インフラップストーリー",
  "인프랩 실Log": "インフラップ実ログ",
  "인프랩 테크": "インフラップテック",
  인프런: "インフラン",
  "인프런 네이버 블로그 바로가기": "インフランネイバーブログ直接リンク",
  "인프런 네이버 포스트 바로가기": "インフランネイバーポスト直接リンク",
  "인프런 메인 페이지로 이동": "インフランメインページに移動",
  "인프런 브랜드 로고": "インフランブランドロゴ",
  "인프런 비즈니스": "インフランビジネス",
  "인프런 소개": "インフラン紹介",
  "인프런 영문 브랜드 로고": "インフラン英文ブランドロゴ",
  "인프런 유튜브 바로가기": "インフランユーチューブ直接リンク",
  "인프런 인스타그램 바로가기": "インフランインスタグラム直接リンク",
  "인프런 제휴": "インフラン提携",
  "인프런 통합 검색": "インフラン統合検索",
  "인프런 트위터 바로가기": "インフラントゥイッター直接リンク",
  "인프런 페이스북 바로가기": "インフランフェイスブック直接リンク",
  "인프런 피드": "インフランフィード",
  "인프런으로 이동하기": "インフランへ移動する",
  잎: "リーフ",
  "자유롭게 학습하는 환경을 제공하세요.": "自由に学習できる環境を提供してください。",
  "자주묻는 질문": "よくある質問",
  "장바구니 페이지로 이동": "カートページに移動",
  "저작권 신고센터": "著作権通報センター",
  전체: "全体",
  "전체 강의": "全体講義",
  "전화번호: 070-4948-1181": "電話番号：070-4948-1181",
  좋아요: "いいね",
  주소: "住所",
  "지금 둘러 보기": "今すぐ見る",
  지식공유: "知識共有",
  "지식공유 참여": "知識共有参加",
  지식공유자: "知識共有者",
  "지식공유자 되기": "知識共有者になる",
  지식공유참여: "知識共有参加",
  "질문 & 답변": "質問と回答",
  "질문 게시판": "質問掲示板",
  "채널톡 아이콘": "チャンネルトークアイコン",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "処理中にエラーが発生しました。しばらくしてから再試行してください。",
  "청강대 게임스쿨": "青江大ゲームスクール",
  초: "秒",
  "총 결제금액": "総決済金額",
  "최근 강의 바로가기": "最近の講義への直接リンク",
  "최근 로그인": "最近のログイン",
  카카오: "カカオ",
  "카카오톡에서 구글 로그인을 지원하지 않습니다.": "カカオトークではグーグルログインをサポートしていません。",
  "카테고리 설정": "カテゴリ設定",
  커리어: "キャリア",
  커뮤니티: "コミュニティ",
  "코드 등록": "コード登録",
  쿠폰: "クーポン",
  "통신판매업: 2018-성남분당B-0062": "通信販売業：2018-城南盆唐B-0062",
  "팀 프로젝트": "チームプロジェクト",
  포인트: "ポイント",
  "포인트코드 등록": "ポイントコード登録",
  학생: "学生",
  "할인 종료까지": "割引終了まで",
  홈: "ホーム",
  확인: "確認",
  회원가입: "会員登録",
  "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 サプライズ感謝割引({{discountPercent}}%)が講義に適用されていますので、今すぐ購入してみてください！",
  "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 新規登録割引({{discountPercent}}%)が講義に適用されていますので、今すぐ購入してみてください！",
  "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 初購入割引({{discountPercent}}%)が講義に適用されていますので、今すぐ購入してみてください！"
}, an = {
  "(주)인프랩": "(주)인프랩",
  "(주)인프랩 사업자 정보": "(주)인프랩 사업자 정보",
  "3동 5층": "3동 5층",
  "IT 인재 채용 서비스": "IT 인재 채용 서비스",
  "MY 카테고리": "MY 카테고리",
  "With us": "With us",
  "{{category.title}} > 전체": "{{category.title}} > 전체",
  "{{name}}님 인프런과 함께 해주셔서 감사해요. 😊": "{{name}}님 인프런과 함께 해주셔서 감사해요.😊",
  "{{name}}님의 첫 도약을 응원하고 있어요. 🙌": "{{name}}님의 첫 도약을 응원하고 있어요. 🙌",
  "{{name}}님의 커리어를 응원하고 있어요. 👏": "{{name}}님의 커리어를 응원하고 있어요. 👏",
  "{{profile?.name}}님의 프로필 이미지": "{{profile?.name}}님의 프로필 이미지",
  "{{provider}}-로그인-버튼": "{{provider}}-로그인-버튼",
  "{{socialProviderNameMap[provider]}}로 로그인": "{{socialProviderNameMap[provider]}}로 로그인",
  "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를": "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를",
  "가입 이메일 인증이 필요합니다.": "가입 이메일 인증이 필요합니다.",
  "간편 로그인": "간편 로그인",
  강의: "강의",
  "강의 · 기능요청": "강의 · 기능요청",
  "강의/강사명을 입력해주세요": "강의/강사명을 입력해주세요",
  "강의리스트 보기": "강의리스트 보기",
  개: "개",
  "개인정보보호책임자: 이동욱": "개인정보보호책임자: 이동욱",
  개인정보처리방침: "개인정보처리방침",
  "경기도 성남시 분당구 판교로289번길 20": "경기도 성남시 분당구 판교로289번길 20",
  "경제적 보상을 받아보세요.": "경제적 보상을 받아보세요.",
  고객센터: "고객센터",
  고민있어요: "고민있어요",
  공지사항: "공지사항",
  교육: "교육",
  구글: "구글",
  "구매 내역": "구매 내역",
  국비지원교육: "국비지원교육",
  기업: "기업",
  "기업 교육을 위한 인프런": "기업 교육을 위한 인프런",
  깃허브: "깃허브",
  "나를 성장 시켜줄 좋은 지식들을 찾아보세요.": "나를 성장 시켜줄 좋은 지식들을 찾아보세요.",
  "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요": "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요",
  "남았어요.": "남았어요.",
  "내 학습": "내 학습",
  "네이버에서 구글 로그인을 지원하지 않습니다.": "네이버에서 구글 로그인을 지원하지 않습니다.",
  "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.": "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.",
  닫기: "닫기",
  "담긴 강의가 없습니다.": "담긴 강의가 없습니다.",
  대시보드: "대시보드",
  "대표자: 이형주": "대표자: 이형주",
  더보기: "더보기",
  "딱 맞는 강의가 기다리고 있어요.": "딱 맞는 강의가 기다리고 있어요.",
  "랠릿 서비스 링크": "랠릿 서비스 링크",
  로그아웃: "로그아웃",
  로그인: "로그인",
  "로그인이 필요한 요청입니다.": "로그인이 필요한 요청입니다.",
  로드맵: "로드맵",
  "마음에 드는 강의를 수강해보세요!": "마음에 드는 강의를 수강해보세요!",
  "많은 사람들에게 배움의 기회를 주고,": "많은 사람들에게 배움의 기회를 주고,",
  "메인 페이지로 이동하기": "메인 페이지로 이동하기",
  멘토링: "멘토링",
  "멘토링 소개": "멘토링 소개",
  "멘토링 후기": "멘토링 후기",
  "모임/부트캠프": "모임/부트캠프",
  "문제가 발생했습니다.": "문제가 발생했습니다.",
  분: "분",
  블로그: "블로그",
  비밀번호: "비밀번호",
  "비밀번호 찾기": "비밀번호 찾기",
  "비밀번호를 입력해주세요.": "비밀번호를 입력해주세요.",
  비즈니스: "비즈니스",
  "비즈니스 브랜드 로고": "비즈니스 브랜드 로고",
  "비즈니스 수강내역": "비즈니스 수강내역",
  "사업자 정보 확인": "사업자 정보 확인",
  "사업자번호: 499-81-00612": "사업자번호: 499-81-00612",
  "사용자 대시보드 페이지로 이동": "사용자 대시보드 페이지로 이동",
  "사용자 알림 페이지로 이동": "사용자 알림 페이지로 이동",
  서비스: "서비스",
  "서비스 언어를 선택하세요.": "서비스 언어를 선택하세요.",
  설정: "설정",
  수강바구니: "수강바구니",
  "수강바구니에서 전체보기": "수강바구니에서 전체보기",
  "수강코드 등록": "수강코드 등록",
  수강평: "수강평",
  "수강평 모아보기": "수강평 모아보기",
  "수료증 확인": "수료증 확인",
  스터디: "스터디",
  시간: "시간",
  신청하기: "신청하기",
  "아이디(이메일) 찾기": "아이디(이메일) 찾기",
  애플: "애플",
  어드민: "어드민",
  "언어 설정": "언어 설정",
  원: "원",
  "유저 대시보드로 이동": "유저 대시보드로 이동",
  "이 공지를 그만 볼래요": "이 공지를 그만 볼래요",
  이메일: "이메일",
  "이메일 또는 비밀번호를 확인해주세요.": "이메일 또는 비밀번호를 확인해주세요.",
  "이메일 형식이 올바르지 않습니다.": "이메일 형식이 올바르지 않습니다.",
  "이메일을 입력해주세요.": "이메일을 입력해주세요.",
  "이어서 학습하기": "이어서 학습하기",
  이용약관: "이용약관",
  인프랩: "인프랩",
  "인프랩 스토리": "인프랩 스토리",
  "인프랩 실Log": "인프랩 실Log",
  "인프랩 테크": "인프랩 테크",
  인프런: "인프런",
  "인프런 네이버 블로그 바로가기": "인프런 네이버 블로그 바로가기",
  "인프런 네이버 포스트 바로가기": "인프런 네이버 포스트 바로가기",
  "인프런 메인 페이지로 이동": "인프런 메인 페이지로 이동",
  "인프런 브랜드 로고": "인프런 브랜드 로고",
  "인프런 비즈니스": "인프런 비즈니스",
  "인프런 소개": "인프런 소개",
  "인프런 영문 브랜드 로고": "인프런 영문 브랜드 로고",
  "인프런 유튜브 바로가기": "인프런 유튜브 바로가기",
  "인프런 인스타그램 바로가기": "인프런 인스타그램 바로가기",
  "인프런 제휴": "인프런 제휴",
  "인프런 통합 검색": "인프런 통합 검색",
  "인프런 트위터 바로가기": "인프런 트위터 바로가기",
  "인프런 페이스북 바로가기": "인프런 페이스북 바로가기",
  "인프런 피드": "인프런 피드",
  "인프런으로 이동하기": "인프런으로 이동하기",
  잎: "잎",
  "자유롭게 학습하는 환경을 제공하세요.": "자유롭게 학습하는 환경을 제공하세요.",
  "자주묻는 질문": "자주묻는 질문",
  "장바구니 페이지로 이동": "장바구니 페이지로 이동",
  "저작권 신고센터": "저작권 신고센터",
  전체: "전체",
  "전체 강의": "전체 강의",
  "전화번호: 070-4948-1181": "전화번호: 070-4948-1181",
  좋아요: "좋아요",
  주소: "주소",
  "지금 둘러 보기": "지금 둘러 보기",
  지식공유: "지식공유",
  "지식공유 참여": "지식공유 참여",
  지식공유자: "지식공유자",
  "지식공유자 되기": "지식공유자 되기",
  지식공유참여: "지식공유참여",
  "질문 & 답변": "질문 & 답변",
  "질문 게시판": "질문 게시판",
  "채널톡 아이콘": "채널톡 아이콘",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
  "청강대 게임스쿨": "청강대 게임스쿨",
  초: "초",
  "총 결제금액": "총 결제금액",
  "최근 강의 바로가기": "최근 강의 바로가기",
  "최근 로그인": "최근 로그인",
  카카오: "카카오",
  "카카오톡에서 구글 로그인을 지원하지 않습니다.": "카카오톡에서 구글 로그인을 지원하지 않습니다.",
  "카테고리 설정": "카테고리 설정",
  커리어: "커리어",
  커뮤니티: "커뮤니티",
  "코드 등록": "코드 등록",
  쿠폰: "쿠폰",
  "통신판매업: 2018-성남분당B-0062": "통신판매업: 2018-성남분당B-0062",
  "팀 프로젝트": "팀 프로젝트",
  포인트: "포인트",
  "포인트코드 등록": "포인트코드 등록",
  학생: "학생",
  "할인 종료까지": "할인 종료까지",
  홈: "홈",
  확인: "확인",
  회원가입: "회원가입",
  "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!",
  "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!",
  "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!"
}, on = {
  "(주)인프랩": "Công ty TNHH Inflab",
  "(주)인프랩 사업자 정보": "Thông tin doanh nghiệp Công ty TNHH Inflab",
  "3동 5층": "Đại Hàn Dân Quốc",
  "IT 인재 채용 서비스": "Dịch vụ tuyển dụng nhân tài IT",
  "MY 카테고리": "Danh mục của tôi",
  "With us": "Cùng chúng tôi",
  "{{category.title}} > 전체": "{{category.title}} > Tất cả",
  "{{name}}님 인프런과 함께 해주셔서 감사해요. 😊": "{{name}}, cảm ơn bạn đã đồng hành cùng Inflearn 😊",
  "{{name}}님의 첫 도약을 응원하고 있어요. 🙌": "{{name}}, chúng tôi cổ vũ bước tiến đầu tiên của bạn 🙌",
  "{{name}}님의 커리어를 응원하고 있어요. 👏": "{{name}}, chúng tôi cổ vũ cho sự nghiệp của bạn 👏",
  "{{profile?.name}}님의 프로필 이미지": "Hình ảnh hồ sơ của {{profile?.name}}",
  "{{provider}}-로그인-버튼": "Nút đăng nhập {{provider}}",
  "{{socialProviderNameMap[provider]}}로 로그인": "Đăng nhập với {{socialProviderNameMap[provider]}}",
  "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를": "Với 'Inflearn Business', tất cả thành viên trong đội có thể tham gia các khóa học của Inflearn",
  "가입 이메일 인증이 필요합니다.": "Cần xác thực email để đăng ký.",
  "간편 로그인": "Đăng nhập nhanh",
  강의: "Khóa học",
  "강의 · 기능요청": "Yêu cầu khóa học/tính năng",
  "강의/강사명을 입력해주세요": "Vui lòng nhập tên khóa học/giảng viên",
  "강의리스트 보기": "Xem danh sách khóa học",
  개: "cái",
  "개인정보보호책임자: 이동욱": "Người phụ trách bảo mật thông tin cá nhân: Lee Dongwook",
  개인정보처리방침: "Chính sách bảo mật",
  "경기도 성남시 분당구 판교로289번길 20": "Tầng 5, Tòa nhà số 3, 20, Pangyo-ro 289beon-gil, Quận Bundang, Thành phố Seongnam, Gyeonggi-do",
  "경제적 보상을 받아보세요.": "Hãy nhận phần thưởng tài chính.",
  고객센터: "Trung tâm khách hàng",
  고민있어요: "Tôi cần giúp đỡ",
  공지사항: "Thông báo",
  교육: "Đào tạo",
  구글: "Google",
  "구매 내역": "Lịch sử mua hàng",
  국비지원교육: "Khóa học được hỗ trợ bởi nhà nước",
  기업: "Doanh nghiệp",
  "기업 교육을 위한 인프런": "Inflearn cho giáo dục doanh nghiệp",
  깃허브: "GitHub",
  "나를 성장 시켜줄 좋은 지식들을 찾아보세요.": "Hãy tìm kiếm những kiến thức tuyệt vời giúp bạn phát triển.",
  "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요": "Tìm các khóa học thực tiễn giúp bạn thực sự phát triển.",
  "남았어요.": "còn lại.",
  "내 학습": "Học tập của tôi",
  "네이버에서 구글 로그인을 지원하지 않습니다.": "Naver không hỗ trợ đăng nhập bằng Google.",
  "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.": "Vui lòng sử dụng trình duyệt di động khác (Chrome, Safari).",
  닫기: "Đóng",
  "담긴 강의가 없습니다.": "Không có khóa học nào trong giỏ hàng.",
  대시보드: "Bảng điều khiển",
  "대표자: 이형주": "Người đại diện: Lee Hyeongjoo",
  더보기: "Xem thêm",
  "딱 맞는 강의가 기다리고 있어요.": "Khóa học phù hợp nhất đang chờ bạn.",
  "랠릿 서비스 링크": "Liên kết dịch vụ Rallit",
  로그아웃: "Đăng xuất",
  로그인: "Đăng nhập",
  "로그인이 필요한 요청입니다.": "Bạn cần đăng nhập để thực hiện yêu cầu này.",
  로드맵: "Lộ trình",
  "마음에 드는 강의를 수강해보세요!": "Hãy tham gia khóa học bạn yêu thích!",
  "많은 사람들에게 배움의 기회를 주고,": "Mang lại cơ hội học tập cho nhiều người,",
  "메인 페이지로 이동하기": "Đi đến trang chính",
  멘토링: "Mentoring",
  "멘토링 소개": "Giới thiệu mentoring",
  "멘토링 후기": "Đánh giá mentoring",
  "모임/부트캠프": "Câu lạc bộ/Bootcamp",
  "문제가 발생했습니다.": "Đã xảy ra sự cố.",
  분: "phút",
  블로그: "Blog",
  비밀번호: "Mật khẩu",
  "비밀번호 찾기": "Tìm mật khẩu",
  "비밀번호를 입력해주세요.": "Vui lòng nhập mật khẩu.",
  비즈니스: "Doanh nghiệp",
  "비즈니스 브랜드 로고": "Logo thương hiệu doanh nghiệp",
  "비즈니스 수강내역": "Lịch sử khóa học doanh nghiệp",
  "사업자 정보 확인": "Kiểm tra thông tin doanh nghiệp",
  "사업자번호: 499-81-00612": "Mã số kinh doanh: 499-81-00612",
  "사용자 대시보드 페이지로 이동": "Đi đến trang bảng điều khiển người dùng",
  "사용자 알림 페이지로 이동": "Đi đến trang thông báo của người dùng",
  서비스: "Dịch vụ",
  "서비스 언어를 선택하세요.": "Vui lòng chọn ngôn ngữ dịch vụ.",
  설정: "Cài đặt",
  수강바구니: "Giỏ khóa học",
  "수강바구니에서 전체보기": "Xem toàn bộ trong giỏ khóa học",
  "수강코드 등록": "Đăng ký mã khóa học",
  수강평: "Đánh giá khóa học",
  "수강평 모아보기": "Xem tất cả đánh giá",
  "수료증 확인": "Xem chứng chỉ hoàn thành",
  스터디: "Câu lạc bộ học tập",
  시간: "giờ",
  신청하기: "Đăng ký",
  "아이디(이메일) 찾기": "Tìm ID (email)",
  애플: "Apple",
  어드민: "Quản trị viên",
  "언어 설정": "Cài đặt ngôn ngữ",
  원: "₫",
  "유저 대시보드로 이동": "Đi đến bảng điều khiển người dùng",
  "이 공지를 그만 볼래요": "Không muốn thấy thông báo này nữa",
  이메일: "Email",
  "이메일 또는 비밀번호를 확인해주세요.": "Vui lòng kiểm tra lại email hoặc mật khẩu.",
  "이메일 형식이 올바르지 않습니다.": "Định dạng email không hợp lệ.",
  "이메일을 입력해주세요.": "Vui lòng nhập email.",
  "이어서 학습하기": "Tiếp tục học",
  이용약관: "Điều khoản sử dụng",
  인프랩: "Inflab",
  "인프랩 스토리": "Câu chuyện về Inflab",
  "인프랩 실Log": "Nhật ký của Inflab",
  "인프랩 테크": "Công nghệ của Inflab",
  인프런: "Inflearn",
  "인프런 네이버 블로그 바로가기": "Đi đến blog Naver của Inflearn",
  "인프런 네이버 포스트 바로가기": "Đi đến bài viết Naver của Inflearn",
  "인프런 메인 페이지로 이동": "Đi đến trang chính của Inflearn",
  "인프런 브랜드 로고": "Logo thương hiệu Inflearn",
  "인프런 비즈니스": "Inflearn doanh nghiệp",
  "인프런 소개": "Giới thiệu Inflearn",
  "인프런 영문 브랜드 로고": "Logo thương hiệu tiếng Anh của Inflearn",
  "인프런 유튜브 바로가기": "Đi đến kênh YouTube của Inflearn",
  "인프런 인스타그램 바로가기": "Đi đến Instagram của Inflearn",
  "인프런 제휴": "Đối tác Inflearn",
  "인프런 통합 검색": "Tìm kiếm trong Inflearn",
  "인프런 트위터 바로가기": "Đi đến X (Twitter) của Inflearn",
  "인프런 페이스북 바로가기": "Đi đến Facebook của Inflearn",
  "인프런 피드": "Bảng tin Inflearn",
  "인프런으로 이동하기": "Đi đến Inflearn",
  잎: "lá",
  "자유롭게 학습하는 환경을 제공하세요.": "Hãy cung cấp một môi trường học tập tự do.",
  "자주묻는 질문": "Câu hỏi thường gặp",
  "장바구니 페이지로 이동": "Đi đến trang giỏ hàng",
  "저작권 신고센터": "Trung tâm báo cáo vi phạm bản quyền",
  전체: "Tất cả",
  "전체 강의": "Tất cả khóa học",
  "전화번호: 070-4948-1181": "Số điện thoại: 070-4948-1181",
  좋아요: "Thích",
  주소: "Địa chỉ",
  "지금 둘러 보기": "Xem ngay bây giờ",
  지식공유: "Chia sẻ kiến thức",
  "지식공유 참여": "Tham gia chia sẻ kiến thức",
  지식공유자: "Người chia sẻ kiến thức",
  "지식공유자 되기": "Trở thành người chia sẻ kiến thức",
  지식공유참여: "Tham gia chia sẻ kiến thức",
  "질문 & 답변": "Hỏi & Đáp",
  "질문 게시판": "Bảng câu hỏi",
  "채널톡 아이콘": "Biểu tượng ChannelTalk",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "Đã xảy ra lỗi trong quá trình xử lý. Vui lòng thử lại sau.",
  "청강대 게임스쿨": "Trường Game Chungkang",
  초: "giây",
  "총 결제금액": "Tổng số tiền thanh toán",
  "최근 강의 바로가기": "Đi đến khóa học gần đây",
  "최근 로그인": "Đăng nhập gần đây",
  카카오: "Kakao",
  "카카오톡에서 구글 로그인을 지원하지 않습니다.": "KakaoTalk không hỗ trợ đăng nhập bằng Google.",
  "카테고리 설정": "Cài đặt danh mục",
  커리어: "Sự nghiệp",
  커뮤니티: "Cộng đồng",
  "코드 등록": "Đăng ký mã",
  쿠폰: "Coupon",
  "통신판매업: 2018-성남분당B-0062": "Ngành bán hàng trực tuyến: 2018-SeongnamBundangB-0062",
  "팀 프로젝트": "Dự án nhóm",
  포인트: "Điểm",
  "포인트코드 등록": "Đăng ký mã điểm",
  학생: "Học sinh",
  "할인 종료까지": "Kết thúc giảm giá trong",
  홈: "Trang chủ",
  확인: "Xác nhận",
  회원가입: "Đăng ký thành viên",
  "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 Giảm giá cảm ơn bất ngờ ({{discountPercent}}%) đã được áp dụng cho khóa học, hãy mua ngay!",
  "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 Giảm giá cho thành viên mới ({{discountPercent}}%) đã được áp dụng cho khóa học, hãy mua ngay!",
  "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 Giảm giá lần mua đầu tiên ({{discountPercent}}%) đã được áp dụng cho khóa học, hãy mua ngay!"
}, Ue = {
  ko: {
    appShell: an
  },
  en: {
    appShell: sn
  },
  vi: {
    appShell: on
  },
  ja: {
    appShell: rn
  }
}, ln = Object.keys(Ue), un = L.createInstance();
un.use(Me).use(ut).init({
  defaultNS: "appShell",
  fallbackLng: se,
  supportedLngs: ln,
  detection: {
    order: ["path"]
  },
  interpolation: {
    escapeValue: !1
  },
  debug: !1,
  cleanCode: !0,
  // e.g. EN -> en
  resources: Ue
});
function cn() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const kn = process.env.NODE_ENV === "production" ? {
  name: "lidyt8",
  styles: "*{box-sizing:border-box;}a{text-decoration:none;}.hidden{display:none;}.disabledScroll{overflow:hidden;}"
} : {
  name: "ncoqxb-globals",
  styles: "*{box-sizing:border-box;}a{text-decoration:none;}.hidden{display:none;}.disabledScroll{overflow:hidden;};label:globals;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9zdHlsZXMvZ2xvYmFscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFbUIiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvZmUtc2hhcmVkL2ZlLXNoYXJlZC9wYWNrYWdlcy9hcHAtc2hlbGwvc3JjL3N0eWxlcy9nbG9iYWxzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5jb25zdCBnbG9iYWxzID0gY3NzYFxuICAqIHtcbiAgICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICB9XG5cbiAgYSB7XG4gICAgdGV4dC1kZWNvcmF0aW9uOiBub25lO1xuICB9XG5cbiAgLmhpZGRlbiB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxuXG4gIC5kaXNhYmxlZFNjcm9sbCB7XG4gICAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgfVxuYDtcblxuZXhwb3J0IGRlZmF1bHQgZ2xvYmFscztcbiJdfQ== */",
  toString: cn
}, Ke = (i) => {
  St() && (window.location.href = i);
}, Be = Pe(void 0);
function Ln({
  navigate: i = Ke,
  children: e
}) {
  return /* @__PURE__ */ Qe(Be.Provider, { value: {
    navigate: i
  }, children: e });
}
const Cn = () => {
  const i = Re(Be);
  return i || (console.warn("[AppShell RouterProvider] not found. Use default navigateWindow"), {
    navigate: Ke
  });
};
export {
  ln as A,
  ct as I,
  Ln as R,
  un as a,
  ut as b,
  vn as c,
  Cn as d,
  se as e,
  D as f,
  kn as g,
  St as h,
  L as i,
  Ke as n,
  wn as o,
  mt as s,
  dt as u
};
